import { StorageService } from 'app/services/storage.service';
import { ContactService } from 'app/services/contact.service';
import { ModalDetailsEditComponent } from 'app/components/shared/modal-details-edit/modal-details-edit.component';

import { throwError as observableThrowError, Observable, Subject } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { DocumentModel } from 'app/models/dms/document.model';
import { CarcheckPricingModel } from 'app/models/carcheck/carCheckPricing.model';

import { MenuService } from 'app/services/menu.service';
import { OpportunityActivity_PriceMyTradeModel } from 'app/models/dms/opportunityActivity.model';
import { CarcheckExistingModel } from 'app/models/carcheck/carCheckExisting.model';
import { PartModel } from 'app/models/dms/part.model';


import { FuelSaverResultModelExtended } from 'app/models/dms/fuelSaverResult.model';
import { ToastController, AlertController, NavController, ModalController, LoadingController } from '@ionic/angular';
import { ExportService } from './export.service';
import { CurrencyModel, LookupExtImageModel, LookupInternalModel, LookupModel } from 'app/models/shared/lookup.model';

import { GeneralService } from './general.service';
import { VehicleClass, SecurityRight, TaxStatusEnum, VehicleStatusEnum, CustomFieldType, VehiclePurchaseType, VehicleExpenseType, PurchaseOrderStatus, VehicleExpenseSaleOrderMode, ContactClass, ContactType, SaleVehicleType, ExternalProcessorControlledField, PlateVinCheck } from 'app/utility/enums';
import { FieldModel } from 'app/models/shared/field.model';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { UserService } from './user.service';
import { VehicleImageModel, VehicleImageConfigModel } from 'app/models/dms/vehicleImage.model';
import { OpportunityActivityResultModel } from 'app/models/dms/opportunityActivityResult.model';
import { VehicleSearchResultModel } from 'app/models/dms/vehicleSearchResult.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { VehicleModel, VehicleSummaryModel, VehicleImagesModel, VehicleAdminModel, VehiclePurchaseModel, VehicleExpensesModel, VehicleExportModel } from 'app/models/dms/vehicle.model';

import { VehicleSearchParamsModel } from 'app/models/dms/vehicleSearchParams.model';
import { Constants } from 'app/utility/constants';
import { VehicleStatusModel } from 'app/models/dms/vehicleStatus.model';
import { HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';
import { ImageIdPairModel } from 'app/models/dms/imageIdPair.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { CacheService } from './cache.service';
import { sequence } from '@angular/animations';
import { TabModel } from 'app/models/shared/tab.model';

import { BooleanResultModel } from 'app/models/shared/booleanResult.model';
import { LicenceModel } from 'app/models/dms/licenceModel';
import { MultipleDocumentsUploadModel, SingleDocumentUploadModel } from 'app/models/shared/documentUpload.model';
import { VehicleCheckVehicle } from 'app/models/vehiclecheck/vehicleCheckVehicle.model';
import { VehicleStatusHistoryModel } from 'app/models/dms/vehicleStatusHistory.model';
import { VehicleTransferHistoryModel } from 'app/models/dms/vehicleTransferHistory.model';
import { VehiclePriceHistoryModel } from 'app/models/dms/vehiclePriceHistory.model';
import { PriceEditorModel } from 'app/models/shared/priceEditor.model';
import { CustomFieldDisplayModel } from 'app/models/shared/customField.model';
import { TasksSearchResult } from 'app/models/dms/tasksSearchResult.model';
import { StringHelper } from 'app/utility/stringhelper';
import { VehicleExpenseModel, VehicleExpensePaymentModel } from 'app/models/dms/vehicleExpense.model';
import { DecimalPipe } from '@angular/common';
import { SelectContactSearchComponent } from 'app/components/shared/select-contact/select-contact-search.component';
import { SaleService } from './sale.service';
import { VehicleOdometerHistoryModel } from 'app/models/dms/vehicleOdometerHistory.model';
import { VehicleProfitCalculatorModel } from 'app/models/dms/vehicleProfitCalculator.model';
import { PartService } from './part.service';
import { BulkUpdateRequestModel } from 'app/models/dms/bulk-update/bulkUpdateRequest.model';



@Injectable({
    providedIn: 'root'
})
export class VehicleService
{
	constructor(
		private httpClient: HttpClient,
		private cache: CacheService,
		private userService: UserService,
		private generalService: GeneralService,
		private exportService: ExportService,
		private toastController: ToastController,
		private alertController: AlertController,
		private navCtrl: NavController,
		private menuService: MenuService,
		private modalController: ModalController,
		private contactService: ContactService,
		public storage: StorageService,
		private decimalPipe: DecimalPipe,
        private saleService: SaleService,
        private loadingController: LoadingController,
        private partService: PartService
	)
	{
		this.getLookups();
		this.menuService.setArea("dms");

		// this.getExportSpecs();
	}

	public getExportSpecs()
	{
		this.exportService.getCachedExportSpecs(false, false).subscribe(w =>
		{
			this.exportSpecs = w.map(v => new ListItemModel(v.id.toString(), v.caption.toString(), null, null, v));
			var a = w.filter(x => x.exportFlagsAllowAuctions == true);
			var b = w.filter(x => x.exportFlagsAllowAuctions == false);
			this.exportSpecsAuction = a.map(v => new ListItemModel(v.id.toString(), v.caption.toString(), null, null, v));
			this.exportSpecsNonAuction = b.map(v => new ListItemModel(v.id.toString(), v.caption.toString(), null, null, v));
		});
	}

	getVehicles(searchParams: VehicleSearchParamsModel): Observable<VehicleSearchResultModel>
	{
		if (searchParams.orderByIn.includes("Desc"))
		{
			searchParams.orderByDesc = true;
		}
		searchParams.orderByIn = searchParams.orderByIn.replace("Desc", "");

		let httpParams = new HttpParams();
		for (var p in searchParams)
		{
			var val = searchParams[p];
			httpParams = httpParams.append(p, val);
		}
		return this.httpClient
			.get<VehicleSearchResultModel>(Constants.ApiUrl + 'vehicles/search', { params: httpParams }).pipe(
				catchError((e: any) => observableThrowError(this.errorHandler(e))));
	}


	errorHandler(error: any): void
	{
		console.error(error);
		if (error.error && error.error.entityDataJson)
		{
			var dtoError = JSON.parse(error.error.entityDataJson);
			// console.log(dtoError);
			this.showToastAlert('An error occurred on server: ' + dtoError.Message);
		}
		else if (error.status == 500)
		{
			this.presentAlert("Server Error", 'An error occurred on the server. Please contact our support team if this error continues.');
		}
		else if (error.status == 404)
		{
			this.presentAlert("Not Found Error", 'This resource was not found. Please contact our support team if this error continues.');
		}
	}

	async showToastAlert(message: string, color: string = "danger", duration: number = 3000)
	{
		const toast = await this.toastController.create({
			message: message,
			buttons: [
				{
					side: 'end',
					icon: 'close-circle-outline',
					role: 'cancel',
					handler: () =>
					{
						toast.dismiss();
					}
				}
			],
			position: 'bottom',
			color: color,
			duration: duration,
			layout: "stacked"
		});
		toast.present();
	}

	async presentAlert(title, message)
	{
		this.userService.presentAlert(title, message);
	}

	populateVehicleThumbnailUrls(vehicles: VehicleSummaryModel[]): void
	{
		for (let vehicle in vehicles)
		{
			let v = vehicles[vehicle];
			this.populateVehicleThumbnailUrl(v);
		}
	}

	populateVehicleThumbnailUrl(v: VehicleSummaryModel): void
	{
		if (v.vehicleThumbnailId !== Constants.EmptyGuid)
		{
			// if (!v.vehicleThumbnailUrl)
			// {
			// 	v.vehicleThumbnailUrl = Constants.ApiUrl + 'vehicles/' + v.vehicleId + '/images/' + v.vehicleThumbnailId + '/thumb?v=' + v.vehicleThumbnailModified;
			// }
			// if (!v.vehicleImageUrl)
			// {
			// 	v.vehicleImageUrl = Constants.ApiUrl + 'vehicles/' + v.vehicleId + '/images/' + v.vehicleThumbnailId + '/child?v=' + v.vehicleThumbnailModified;
			// }
			if (!v.vehicleThumbnailUrl)
			{
				v.vehicleThumbnailUrl = Constants.PlaceholderPosterUrl;
			}
		}
		else
		{
			if (!v.vehicleThumbnailUrl)
			{
				v.vehicleThumbnailUrl = Constants.PlaceholderCarUrl;
			}
			if (!v.vehicleImageUrl)
			{
				v.vehicleImageUrl = Constants.PlaceholderCarUrl;
			}
		}
	}

	getVehicleTemplate(vehicleClass: string, dealershipId: string, plateVin: string, purchaseType: number = 10)
	{

		let httpParams = new HttpParams();
		httpParams = httpParams.set('vehicleClass', vehicleClass);
		httpParams = httpParams.set('dealershipId', dealershipId);
		httpParams = httpParams.set('purchaseType', purchaseType);
        if (plateVin.length > 6)
        {
            httpParams = httpParams.set('vin', plateVin);
        }
        else
        {
            httpParams = httpParams.set('regNo', plateVin);
        }
		return this.httpClient.get<VehicleModel>(Constants.ApiUrl + 'vehicles/New', { params: httpParams });
	}


	getVehicleSummaryById(vehicleId: string): Observable<VehicleSummaryModel>
	{
		return this.httpClient.get<VehicleSummaryModel>(Constants.ApiUrl + 'vehicles/by-id/' + vehicleId + '/summary');
	}

	getVehicleAdminById(vehicleId: string): Observable<VehicleAdminModel>
	{
		return this.httpClient.get<VehicleAdminModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/admin');
	}

	getVehicleSummaryByStockNo(stockNo: string): Observable<VehicleSummaryModel>
	{
		return this.httpClient.get<VehicleSummaryModel>(Constants.ApiUrl + 'vehicles/by-stockNo/' + stockNo + '/summary');
	}

	getVehicleById(vehicleId: string,
		sideloadExpenses: boolean = false,
		sideloadImages: boolean = false,
		sideloadActivities: boolean = false,
		sideloadPurchaseOrders: boolean = false,
		sideloadLastActivity: boolean = false,
		sideloadLockStatus: boolean = false
	): Observable<VehicleModel>
	{

		let params = "";
		if (sideloadExpenses) params += "&sideloadOption=Expenses"
		if (sideloadImages) params += "&sideloadOption=Images"
		if (sideloadActivities) params += "&sideloadOption=Activities"
		if (sideloadPurchaseOrders) params += "&sideloadOption=PurchaseOrders"
		if (sideloadLastActivity) params += "&sideloadOption=LastActivity"
		if (sideloadLockStatus) params += "&sideloadOption=LockStatus"

		return this.httpClient.get<VehicleModel>(Constants.ApiUrl + 'vehicles/by-id/' + vehicleId + '?' + params);
	}

	getVehicleOpportunityCount(vehicleId: string): Observable<number>
	{
		return this.httpClient.get<number>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/OpportunityCount');
	}

	getVehicleLastActivity(vehicleId: string): Observable<OpportunityActivityResultModel>
	{
		return this.httpClient.get<OpportunityActivityResultModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Activities/Latest');
	}

	getVehicleImagesByVehicleId(vehicleId: string): Observable<VehicleImagesModel>
	{
		return this.httpClient.get<VehicleImagesModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/images');
	}

	public updateVehicleImagesSequence(vehicleId: string, vehicleImages: VehicleImagesModel): Observable<VehicleImagesModel>
	{
		let options = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		return this.httpClient.patch<VehicleImagesModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/images', vehicleImages, options);
	}

	saveVehicle(vehicle: VehicleModel): Observable<VehicleModel>
	{
		if (vehicle.id == Constants.EmptyGuid)
		{
			return this.httpClient.post<VehicleModel>(Constants.ApiUrl + 'vehicles/new', vehicle);
		}

		return this.httpClient.put<VehicleModel>(Constants.ApiUrl + 'vehicles/' + vehicle.id, vehicle);
	}

	saveVehicleAdmin(vehicleAdmin: VehicleAdminModel): Observable<VehicleModel>
	{
		return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'vehicles/' + vehicleAdmin.vehicleId + '/admin', vehicleAdmin);
	}

    saveVehicleExport(vehicleAdmin: VehicleExportModel): Observable<VehicleModel>
	{
		return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'vehicles/' + vehicleAdmin.vehicleId + '/export', vehicleAdmin);
	}

	saveVehicleSupplier(vehicleId: string, supplierId: string)
	{
		return this.httpClient.patch<boolean>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Supplier/' + supplierId, '');
	}

	saveVehicleStatus(vehicleId: string, status: number)
	{
		return this.httpClient.patch<boolean>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Status/' + status, '');
	}

	saveVehicleExpenses(vehicleId: string, expenses: VehicleExpenseModel[]): Observable<VehicleExpenseModel[]>
	{
		return this.httpClient.patch<VehicleExpenseModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/expenses', expenses);
	}

	updateVehicleActive(vehicleId: string, active: boolean = null)
	{
		return this.httpClient.patch<BooleanResultModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Active/' + active, '');
	}

    deleteVehicle(vehicleId: string, reason: string)
	{
        var httpParams = new HttpParams();
        httpParams = httpParams.set('reason', reason);
		return this.httpClient.delete<BooleanResultModel>(Constants.ApiUrl + 'vehicles/' + vehicleId, { params: httpParams });
	}

	getVehicleActivities(vehicleId: string): Observable<OpportunityActivityResultModel[]>
	{
		return this.httpClient.get<OpportunityActivityResultModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/activities');
	}

	public getCachedVehiclesIndex(dealershipId: string = Constants.EmptyGuid, vehicleSoldState: string = "All"): Observable<string[]>
	{
		let cacheKey: string = 'vehiclesIndex-' + dealershipId.toString() + '-' + vehicleSoldState.toString();
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getVehiclesIndex(dealershipId, vehicleSoldState), cacheMilliseconds);
	}

	public getVehiclesIndex(dealershipId: string, vehicleSoldState: string): Observable<string[]>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('dealershipId', dealershipId.toString());
		httpParams = httpParams.set('vehicleSoldState', vehicleSoldState.toString());
		return this.httpClient.get<string[]>(Constants.ApiUrl + 'vehicles/index', { params: httpParams });
	}

	public uploadImages(vehicleId: string, files: Blob[]): Observable<any>
	{
		let url = Constants.ApiUrl + 'vehicles/' + vehicleId + '/images/new';

		const formData = new FormData();
		for (var i = 0; i < files.length; i++)
		{
			formData.append('image', files[i]);
		}
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });

	}

	public uploadDocuments(vehicleId: string, files: Blob[], title: string, documentCategory: string, uploadDocumentName: string[]): Observable<any>
	{
		let url = Constants.ApiUrl + 'vehicles/' + vehicleId + '/document/new';

		const formData = new FormData();
		for (var i = 0; i < files.length; i++)
		{
			formData.append('document', files[i]);
			formData.append('title', title);
			formData.append('documentCategory', documentCategory);
			formData.append('uploadDocumentName', uploadDocumentName[i]);
		}
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });

	}

	public updateDocument(vehicleId: string, documentUri: string, fileDesc: string, fileCategory: number): Observable<SingleDocumentUploadModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);
		httpParams = httpParams.append('fileDesc', fileDesc);
		httpParams = httpParams.append('fileCategory', fileCategory);
		return this.httpClient.patch<SingleDocumentUploadModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/document/update', httpParams);
	}

	public deleteDocument(vehicleId: string, documentUri: string): Observable<Array<DocumentModel>>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);

		return this.httpClient.delete<Array<DocumentModel>>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/document/delete', { params: httpParams });
	}


	/**
	 * Converts data uri to Blob. Necessary for uploading.
	 * @see
	 *   http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
	 * @param  {String} dataURI
	 * @return {Blob}
	 */
	public base64toBlob(byteString)
	{
		return StringHelper.base64toBlob(byteString); //convert base64/URLEncoded data component to raw binary data held in a string
	}



	// public uploadImage(vehicle: VehicleModel, image: Blob): Observable<string[]>
	// {
	//     let url = Constants.ApiUrl + 'vehicles/' + vehicle.id + '/images/new';
	//     return Observable.fromPromise(new Promise((resolve, reject) => {
	//         let formData: any = new FormData()
	//         let xhr = new XMLHttpRequest()
	//         formData.append("image", image)
	//         xhr.onreadystatechange = function () {
	//             if (xhr.readyState === 4) {
	//                 if (xhr.status === 200) {
	//                     resolve(JSON.parse(xhr.response))
	//                 } else {
	//                     reject(xhr.response)
	//                 }
	//             }
	//         }
	//         xhr.open("POST", url, true)
	//         xhr.setRequestHeader('Authorization',  `Bearer ${this.userService.getToken()}`)
	//         xhr.send(formData)
	//     }));

	// }

	//https://stackoverflow.com/questions/37749505/xmlhttprequest-with-observable-in-typescript/37750209#37750209
	// makeFileRequest(url: string, files: Array<File>) {
	//     return Observable.fromPromise(new Promise((resolve, reject) => {
	//         let formData: any = new FormData()
	//         let xhr = new XMLHttpRequest()
	//         for (let file of files) {
	//             formData.append("uploads[]", file, file.name)
	//         }
	//         xhr.onreadystatechange = function () {
	//             if (xhr.readyState === 4) {
	//                 if (xhr.status === 200) {
	//                     resolve(JSON.parse(xhr.response))
	//                 } else {
	//                     reject(xhr.response)
	//                 }
	//             }
	//         }
	//         xhr.open("POST", url, true)
	//         xhr.send(formData)
	//     }));
	// }


	public getCachedVehiclesImageConfig(): Observable<VehicleImageConfigModel>
	{
		let cacheKey: string = 'vehiclesImageConfig';
		let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
		return this.cache.get(cacheKey, this.getVehiclesImageConfig(), cacheMilliseconds);
	}

	public getVehiclesImageConfig(): Observable<VehicleImageConfigModel>
	{
		let httpParams = new HttpParams();
		return this.httpClient.get<VehicleImageConfigModel>(Constants.ApiUrl + 'Vehicles/ConfigImage', { params: httpParams });
	}

	public deleteVehicleImages(vehicleId: string, imageIds: string[]): Observable<VehicleImagesModel>
	{
		// console.log(imageIds);
		let httpParams = new HttpParams();
		for (let x in imageIds)
		{
			var imageId = imageIds[x];
			httpParams = httpParams.append('imageId', imageId);
		}
		// console.log(httpParams);

		return this.httpClient.delete<VehicleImagesModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/images', { params: httpParams });
	}

	public setVehicle(vehicle: VehicleModel)
	{
		this.vehicle = vehicle;
	}

	taxStatuses: ListItemModel[];//get full list of tax statuses
	exportSpecs: ListItemModel[];
	exportSpecsAuction: ListItemModel[];
	exportSpecsNonAuction: ListItemModel[];
	public fieldGroupTabs: TabModel[];
	field_groups: FieldGroupModel[];
	private vehicle: VehicleModel;
	private editActive: boolean = false;
	public setupFieldGroups(vehicle: VehicleModel, isExpress: boolean, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
	{
		this.vehicle = vehicle;
		this.editActive = editActive;

		this.generalService.getCachedTaxStatuses(false).subscribe(w =>
		{
			this.taxStatuses = w.map(v => new ListItemModel(v.taxStatusEnum.toString(), v.name.toString(), null, null, v));
		});

		this.fieldGroupTabs = [];


		//Summary tab for people with no permissions
		if (!editActive)
		{
			this.fieldGroupTabs.push(new TabModel("summary", this.vehicle.vehicleSummary, this.getFieldGroups("summary"), makeDirty, "summary", "", true, false));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralView))
		{
			this.fieldGroupTabs.push(new TabModel("general", this.vehicle.vehicleGeneral, this.getFieldGroups("general"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralView), this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
		{
			this.fieldGroupTabs.push(new TabModel("purchase", this.vehicle.vehiclePurchase, this.getFieldGroups("purchase"), makeDirty, "purchase", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExpensesView) && !isExpress)
		{
			this.fieldGroupTabs.push(new TabModel("expenses", this.vehicle.vehicleExpenses, this.getFieldGroups("expenses"), makeDirty, "expenses", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsExpensesView), false));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExteriorView))
		{
			this.fieldGroupTabs.push(new TabModel("exterior", this.vehicle.vehicleExterior, this.getFieldGroups("exterior"), makeDirty, "exterior", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsExteriorView), this.userService.hasUserRight(SecurityRight.VehiclesTabsExteriorEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsInteriorView))
		{
			this.fieldGroupTabs.push(new TabModel("interior", this.vehicle.vehicleInterior, this.getFieldGroups("interior"), makeDirty, "interior", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsInteriorView), this.userService.hasUserRight(SecurityRight.VehiclesTabsInteriorEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsMechanicalView))
		{
			this.fieldGroupTabs.push(new TabModel("mechanical", this.vehicle.vehicleMechanical, this.getFieldGroups("mechanical"), makeDirty, "mechanical", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsMechanicalView), this.userService.hasUserRight(SecurityRight.VehiclesTabsMechanicalEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExportView))
		{
			this.fieldGroupTabs.push(new TabModel("export", this.vehicle.vehicleExport, this.getFieldGroups("export"), makeDirty, "export", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsExportView), this.userService.hasUserRight(SecurityRight.VehiclesTabsExportEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminView) && this.vehicle.vehicleAdmin)
		{
			this.fieldGroupTabs.push(new TabModel("admin", this.vehicle.vehicleAdmin, this.getFieldGroups("admin"), makeDirty, "admin", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminView), this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit)));
		}
		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsImagesView) && this.vehicle.vehicleImages && this.userService.mcMinVersion("3.2.19"))
		{
			this.fieldGroupTabs.push(new TabModel("media", this.vehicle.vehicleImages, this.getFieldGroups("images"), makeDirty, "images", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsImagesView), this.userService.hasUserRight(SecurityRight.VehiclesTabsImagesEdit)));
		}
		if (this.userService.mcMinVersion("3.2.20") && this.userService.hasUserRight(SecurityRight.VehiclesTabsCustomView))
		{
			this.fieldGroupTabs.push(new TabModel("custom", this.vehicle.vehicleCustomFields, this.getFieldGroups("custom"), makeDirty, "custom", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsCustomView), this.userService.hasUserRight(SecurityRight.VehiclesTabsCustomEdit)));
		}
		// console.log(this.fieldGroupTabs);
		return this.fieldGroupTabs;
	}

	public getFieldGroups(groupId: string): FieldGroupModel[]
	{
		var field_groups: FieldGroupModel[] = [];
		var field_group: FieldGroupModel;
		switch (groupId)
		{
			case 'summary':

				field_group = new FieldGroupModel('Identification');
                if (this.userService.mcMinVersion("3.2.23") && this.vehicle.vehicleSummary.regNo)
                {
                    field_group.editLink = true;
                }
				field_group.addField(new FieldModel("VIN", this.vehicle.vehicleSummary.vin));
				field_group.addField(new FieldModel("Plate No.", this.vehicle.vehicleSummary.regNo));
				field_group.addField(new FieldModel("Ext. Colour", this.vehicle.vehicleSummary.extColorCaption));
				field_group.addField(new FieldModel("Int. Colour", this.vehicle.vehicleSummary.intColorCaption));
				field_groups.push(field_group);

				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
				{
					field_group = new FieldGroupModel('Purchase');
					field_group.addField(new FieldModel("Purchase Date", this.vehicle.vehiclePurchase.purchaseDate, "date"));
					field_group.addField(new FieldModel("Purchase Type", this.vehicle.vehiclePurchase.purchaseType.caption));
					field_group.addField(new FieldModel("Supplier", this.vehicle.vehiclePurchase.purchaseSupplierName));
					field_groups.push(field_group);
				}


				field_group = new FieldGroupModel('Mechanical');
				field_group.addField(new FieldModel("Odometer", this.numberWithCommas(this.vehicle.vehicleSummary.odometerCaption), "text"));
				field_group.addField(new FieldModel("Engine Size", this.numberWithCommas(this.vehicle.vehicleSummary.engineSizeCaption), "text"));
				field_group.addField(new FieldModel("Transmission", this.numberWithCommas(this.vehicle.vehicleSummary.transmissionCaption), "text"));
				field_group.addField(new FieldModel("Fuel Type", this.numberWithCommas(this.vehicle.vehicleSummary.fuelTypeCaption), "text"));

				field_groups.push(field_group);

				//add permission-based summaru info

				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralView))
				{

				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExpensesView))
				{

				}


				field_group = new FieldGroupModel('Features');
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExteriorView))
				{
					field_group.addField(new FieldModel("Number of Doors", this.vehicle.vehicleExterior.doorNo));
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsInteriorView))
				{
					field_group.addField(new FieldModel('Number of Seats', this.vehicle.vehicleInterior.seatNo, 'number', 'seatNo', true, false, null));
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExteriorView))
				{
					field_group.addField(new FieldModel('Exterior Features', this.vehicle.vehicleExterior.exteriorFeatureIds, 'lookups', 'exteriorFeatureIds', true, false, this.vehicle.vehicleExterior.exteriorFeatureLookups, '', this.vehicle.vehicleClass));
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsInteriorView))
				{
					if (this.vehicle.vehicleClass == VehicleClass.Caravan ||
						this.vehicle.vehicleClass == VehicleClass.Machine ||
						this.vehicle.vehicleClass == VehicleClass.Motorhome ||
						this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
						this.vehicle.vehicleClass == VehicleClass.Boat)
					{
						field_group.addField(new FieldModel('Interior Features', this.vehicle.vehicleInterior.interiorFeatureIds, 'lookups', 'interiorFeatureIds', true, false, this.vehicle.vehicleInterior.interiorFeatureLookups, '', this.vehicle.vehicleClass));
					}
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsMechanicalView))
				{
					if (this.userService.hasUserRight(SecurityRight.VehiclesTabsGeneralView))
					{
						if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
						{
							if (!this.editActive && this.vehicle.vehicleGeneral.fuelSaverResult && this.vehicle.vehicleGeneral.fuelSaverResult.fuelSaverImage)
							{
								field_group.addField(new FieldModel('Fuel Economy Rating', Constants.ApiUrl + this.vehicle.vehicleGeneral.fuelSaverResult.fuelSaverImage, 'image', 'fuelSaverResult', false, false, null));
							}
						}
					}

					if (this.vehicle.vehicleClass == VehicleClass.Boat || this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
					{
						var lookupModel = new LookupModel();
						lookupModel.collection = "VehicleMechanicalFeatures";
						lookupModel.lookupType = "external";
						field_group.addField(new FieldModel('Mechanical Features', this.vehicle.vehicleMechanical.mechanicalFeatureIds, 'lookups', 'mechanicalFeatureIds', true, false, this.vehicle.vehicleMechanical.mechanicalFeatureLookups, '', this.vehicle.vehicleClass));
					}
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsExportView))
				{

				}

				field_groups.push(field_group);

				field_group = new FieldGroupModel('Admin');
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminView) && this.vehicle.vehicleAdmin)
				{
					field_group.addField(new FieldModel('Licensing Expiry Date', this.vehicle.vehicleAdmin.regExpiryDate, 'date', 'regExpiryDate', true, false, null));
					field_group.addField(new FieldModel('WOF/COF Expiry Date', this.vehicle.vehicleAdmin.cofExpiryDate, 'date', 'cofExpiryDate', true, false, null));
					field_group.addField(new FieldModel('Owner Dealership', this.vehicle.vehicleAdmin.companyId, 'contact', 'companyId', false, false, this.vehicle.vehicleAdmin.company));
				}
				if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
				{
					field_group.addField(new FieldModel('Appraised By', this.vehicle.vehiclePurchase.appraisedById, 'contact', 'appraisedById', true, false, this.vehicle.vehiclePurchase.appraisedBy));
				}
				field_groups.push(field_group);

				break;
			case 'general':
				field_group = new FieldGroupModel('Make');

				var manufacturer = new FieldModel('Manufacturer', this.vehicle.vehicleGeneral.manufacturerId, 'lookup', 'manufacturerId', true, false, this.vehicle.vehicleGeneral.manufacturer);
				manufacturer.hasChildren = true;
				manufacturer.detailClass = this.vehicle.vehicleClass;
				field_group.addField(manufacturer);

				var model = new FieldModel('Model', this.vehicle.vehicleGeneral.modelId, 'lookup', 'modelId', true, false, this.vehicle.vehicleGeneral.model);
				model.parent = "manufacturerId";
				model.parentLookupId = this.vehicle.vehicleGeneral.manufacturerId;
				model.hasChildren = true;
				model.detailClass = this.vehicle.vehicleClass;
				field_group.addField(model);

				var variant = new FieldModel('Variant', this.vehicle.vehicleGeneral.variantId, 'lookup', 'variantId', true, false, this.vehicle.vehicleGeneral.variant);
				variant.parent = "modelId";
				variant.parentLookupId = this.vehicle.vehicleGeneral.modelId;
				variant.detailClass = this.vehicle.vehicleClass;
				field_group.addField(variant);
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Vehicle Year');
				field_group.addField(new FieldModel('Year', this.vehicle.vehicleGeneral.manuYear, 'text', 'manuYear', true, true, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Body');
				field_group.addField(new FieldModel('Body Style', this.vehicle.vehicleGeneral.bodyStyleId, 'lookup', 'bodyStyleId', true, false, this.vehicle.vehicleGeneral.bodyStyle, '', this.vehicle.vehicleClass));

				if (this.vehicle.vehicleClass == VehicleClass.Caravan ||
					this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Machine)
				{
					field_group.addField(new FieldModel('Chassis Extras', this.vehicle.vehicleGeneral.chassisExtras, 'text', 'chassisExtras', true, false, null));
					field_group.addField(new FieldModel('Chassis Type', this.vehicle.vehicleGeneral.chassisType, 'text', 'chassisType', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					field_group.addField(new FieldModel('Hull Type', this.vehicle.vehicleGeneral.constructTypeId, 'lookup', 'constructTypeId', true, false, this.vehicle.vehicleGeneral.constructType));
				}
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Registration');
				var registeredLocal = new FieldModel('Registered on the NZ Motor Vehicle Register', this.vehicle.vehicleGeneral.adminFlagsRegisteredLocal, 'toggle', 'adminFlagsRegisteredLocal', true, false, null);
				registeredLocal.hasChildren = true;
				field_group.addField(registeredLocal);

				var regNo = new FieldModel('Registration Plate No', this.vehicle.vehicleGeneral.regNo, 'text', 'regNo', this.vehicle.vehicleGeneral.adminFlagsRegisteredLocal, false, null);
				regNo.parent = 'adminFlagsRegisteredLocal';
				regNo.toggleEditableWhen = 'true';
				// regNo.hasButton = true;
				// regNo.buttonText = "Fetch Car Check details";
				// regNo.buttonIcon = "icon-CarCheck";
				// regNo.buttonName = "button-carcheck";
				field_group.addField(regNo);

				field_group.addField(new FieldModel('Re-Registered Vehicle', this.vehicle.vehicleGeneral.adminFlagsReRegisteredLocal, 'toggle', 'adminFlagsReRegisteredLocal', true, false, null));
				field_group.addField(new FieldModel('Year First Registered NZ', this.vehicle.vehicleGeneral.regYearLocal, 'text', 'regYearLocal', true, false, null));
				field_groups.push(field_group);

                if (this.userService.mcMinVersion("3.2.23") && this.userService.hasUserRight(SecurityRight.VehiclesFunctionsEditStockNo))
                {
                    field_group = new FieldGroupModel('Stock ID');
                    var stockNo = new FieldModel('Stock No', this.vehicle.vehicleGeneral.stockNo, 'number', 'stockNo', false, false, null);
                    field_group.addField(stockNo);
                    if (!this.editActive)
                    {
                        var stockNoButton = new FieldModel('Change stock no', '', 'button', 'stockNumberChange', false, false, null, "button-stock-number");
                        stockNoButton.buttonExpand = 'block';
                        stockNoButton.buttonSize = 'small';
                        field_group.addField(stockNoButton);
                    }
                    field_groups.push(field_group);
                }

                


				if (this.userService.mcMinVersion("3.2.13"))
				{
					field_group = new FieldGroupModel('Hubometer');
					field_group.addField(new FieldModel('Serial No', this.vehicle.vehicleGeneral.hubSerialNo, 'text', 'hubSerialNo', true, false, null));
					field_group.addField(new FieldModel('Model No', this.vehicle.vehicleGeneral.hubModelNo, 'text', 'hubModelNo', true, false, null));
					field_groups.push(field_group);
				}


				field_group = new FieldGroupModel('Identification');

				var vin = new FieldModel('VIN', this.vehicle.vehicleGeneral.vin, 'text', 'vin', true, false, null);
				// vin.hasButton = true;
				// vin.buttonText = "Fetch Car Check details";
				// vin.buttonIcon = "icon-CarCheck";
				// vin.buttonName = "button-carcheck";
				field_group.addField(vin);

				field_group.addField(new FieldModel('Chassis No', this.vehicle.vehicleGeneral.chassisNo, 'text', 'chassisNo', true, false, null));

				if (this.vehicle.vehicleClass != VehicleClass.Boat)
				{
					field_group.addField(new FieldModel('Engine No', this.vehicle.vehicleGeneral.engineNo, 'text', 'engineNo', true, false, null));
				}
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Dimensions and Mass');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Wheelbase (mm)', this.vehicle.vehicleGeneral.wheelbase, 'text', 'wheelbase', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					var unit = this.userService.mcMinVersion("3.2.0") ? '(m)' : '(cm)';
					field_group.addField(new FieldModel('Length ' + unit, this.vehicle.vehicleGeneral.boatLength, 'decimal', 'boatLength', true, false, null));
					field_group.addField(new FieldModel('Beam ' + unit, this.vehicle.vehicleGeneral.boatBeam, 'decimal', 'boatBeam', true, false, null));
					field_group.addField(new FieldModel('Draft ' + unit, this.vehicle.vehicleGeneral.boatDraft, 'decimal', 'boatDraft', true, false, null));
					field_group.addField(new FieldModel('Dry Weight (kg)', this.vehicle.vehicleGeneral.dryWeight, 'text', 'dryWeight', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Caravan)
				{
					field_group.addField(new FieldModel('Caravan Length (ft)', this.vehicle.vehicleGeneral.caravanLength, 'decimal', 'caravanLength', true, false, null));
					field_group.addField(new FieldModel('Caravan Width (ft)', this.vehicle.vehicleGeneral.caravanWidth, 'decimal', 'caravanWidth', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle)
				{
					field_group.addField(new FieldModel('Deck Height (m)', this.vehicle.vehicleGeneral.deckHeight, 'decimal', 'deckHeight', true, false, null));
					field_group.addField(new FieldModel('Deck Width (m)', this.vehicle.vehicleGeneral.deckWidth, 'decimal', 'deckWidth', true, false, null));
					field_group.addField(new FieldModel('Deck Length (m)', this.vehicle.vehicleGeneral.deckLength, 'decimal', 'deckLength', true, false, null));
					field_group.addField(new FieldModel('GVM (kg)', this.vehicle.vehicleGeneral.gvm, 'number', 'gvm', true, false, null));
					field_group.addField(new FieldModel('TARE (kg)', this.vehicle.vehicleGeneral.tare, 'number', 'tare', true, false, null));
					field_group.addField(new FieldModel('GLW (kg)', this.vehicle.vehicleGeneral.glw, 'number', 'glw', true, false, null));
					field_group.addField(new FieldModel('GCW (kg)', this.vehicle.vehicleGeneral.gcw, 'number', 'gcw', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Seat Height (mm)', this.vehicle.vehicleGeneral.seatHeight, 'text', 'seatHeight', true, false, null));
					field_group.addField(new FieldModel('Ground Clearance (mm)', this.vehicle.vehicleGeneral.groundClearance, 'text', 'groundClearance', true, false, null));
					field_group.addField(new FieldModel('Dry Weight (kg)', this.vehicle.vehicleGeneral.dryWeight, 'text', 'dryWeight', true, false, null));
					field_group.addField(new FieldModel('Fuel Capacity (l)', this.vehicle.vehicleGeneral.fuelCapacity, 'text', 'fuelCapacity', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorhome)
				{
					field_group.addField(new FieldModel('Motorhome Length (m)', this.vehicle.vehicleGeneral.motorhomeLength, 'decimal', 'motorhomeLength', true, false, null));
					field_group.addField(new FieldModel('Motorhome Width (m)', this.vehicle.vehicleGeneral.motorhomeWidth, 'decimal', 'motorhomeWidth', true, false, null));
				}
				if (field_group.fields.length)
				{
					field_groups.push(field_group);
				}

				if (!this.editActive &&
					this.vehicle.vehicleGeneral.fuelSaverResult.reference &&
					this.userService.mcMinVersion("3.2.11"))
				{
					field_group = new FieldGroupModel('Ratings');

					var fuelEconomy = new FieldModel('Fuel Economy', this.vehicle.vehicleGeneral.fuelSaverResult.fuelStars, 'stars', 'fuelRating', false);
					fuelEconomy.detailObject = 6;
					fuelEconomy.footernote = this.vehicle.vehicleGeneral.fuelSaverResult.fuelEconomyText + ((this.vehicle.vehicleGeneral.fuelSaverResult.fuelEconomyText) ? "; " : "") + this.vehicle.vehicleGeneral.fuelSaverResult.annFuelCostText;
					field_group.addField(fuelEconomy);

					var safetyStars = new FieldModel('Safety Rating', this.vehicle.vehicleGeneral.fuelSaverResult.driverSafetyStars, 'stars', 'fuelRating', false);
					safetyStars.detailObject = 5;
					safetyStars.footernote = this.vehicle.vehicleGeneral.fuelSaverResult.driverSafetyTest;
					field_group.addField(safetyStars);

					var cO2Stars = new FieldModel('Carbon Emissions', this.vehicle.vehicleGeneral.fuelSaverResult.cO2Stars, 'stars', 'fuelRating', false);
					cO2Stars.detailObject = 6;
					cO2Stars.footernote = this.vehicle.vehicleGeneral.fuelSaverResult.cO2Text + "; " + this.vehicle.vehicleGeneral.fuelSaverResult.cO2YearlyCaption;
					field_group.addField(cO2Stars);

					field_group.addField(new FieldModel('Last Query Date', this.vehicle.vehicleGeneral.fuelSaverResult.lastQueryDate, 'date', 'lastQueryDate', false));
					field_group.addField(new FieldModel('Reference', this.vehicle.vehicleGeneral.fuelSaverResult.reference, 'text', 'reference', false));

					field_groups.push(field_group);
				}
				break;
			case 'purchase':
				field_group = new FieldGroupModel('Purchase');
				field_group.addField(new FieldModel('Purchase Date', this.vehicle.vehiclePurchase.purchaseDate, 'date', 'purchaseDate', true, false, null));
				field_group.addField(new FieldModel('Purchase Type', this.vehicle.vehiclePurchase.purchaseTypeId, 'lookup', 'purchaseTypeId', (this.vehicle.vehiclePurchase.purchaseType.caption == "Trade" ? false : true), false, this.vehicle.vehiclePurchase.purchaseType));


				if (!this.editActive && this.userService.hasUserRight(SecurityRight.VehiclesFunctionsAccessPurchaseCosts))
				{
					field_group.addField(new FieldModel('Purchase Cost', this.vehicle.vehiclePurchase.vehicleLandedCost, 'text', 'landedCost', false, false, null));
					field_group.addField(new FieldModel('Purchase Cost Tax Amount', this.vehicle.vehiclePurchase.vehicleLandedCostGst, 'text', 'vehicleLandedCostGst', false, false, null));
				}

				if (this.vehicle.vehiclePurchase.vehicleWriteBack > 0)
				{
					field_group.addField(new FieldModel('Vehicle Writeback', this.vehicle.vehiclePurchase.vehicleWriteBack, 'currency', 'vehicleWriteBack', false, false, null));
				}

				// field_group.addField(new FieldModel('Supplier', this.vehicle.vehiclePurchase.purchaseSupplierName, 'text', 'purchaseSupplierName', true, false, null));
				field_group.addField(new FieldModel('Trader Acquisition MR13C Applies', this.vehicle.vehiclePurchase.purchaseFlagsTraderAcquisitionApplies, 'toggle', 'purchaseFlagsTraderAcquisitionApplies', true, false, null));
				field_group.addField(new FieldModel('Trader Acquisition Completed', this.vehicle.vehiclePurchase.purchaseFlagsTraderAcquisitionCompleted, 'toggle', 'purchaseFlagsTraderAcquisitionCompleted', true, false, null));
				field_group.addField(new FieldModel('Purchase Notes', this.vehicle.vehiclePurchase.purchaseDesc, 'longtext', 'purchaseDesc', true, false, null));
				field_group.addField(new FieldModel('Auction Grade', this.vehicle.vehiclePurchase.auctionGrade, 'text', 'auctionGrade', true, false, null));

				var vehicleAppraisalValueObject = new PriceEditorModel();
				vehicleAppraisalValueObject.removeTaxTypes = true;
				vehicleAppraisalValueObject.price = { id: "appraisalAmount", value: this.vehicle.vehiclePurchase.appraisalAmount };
				vehicleAppraisalValueObject.taxType = { id: "appraisalTaxStatusEnum", value: this.vehicle.vehiclePurchase.appraisalTaxStatusEnum };
				vehicleAppraisalValueObject.mode = "extended";
				vehicleAppraisalValueObject.currency = { id: "appraisalCurrencyId", value: "" };
				vehicleAppraisalValueObject.taxRate = { id: "appraisalTaxRate", value: this.vehicle.vehiclePurchase.appraisalTaxRate };
				vehicleAppraisalValueObject.taxAmount = { id: "appraisalTaxAmount", value: this.vehicle.vehiclePurchase.appraisalTaxAmount };
				field_group.addField(new FieldModel("Vehicle Appraisal", this.vehicle.vehiclePurchase.appraisalAmount, "price", "appraisalAmount", true, false, vehicleAppraisalValueObject));

				field_group.addField(new FieldModel('Appraised By', this.vehicle.vehiclePurchase.appraisedById, 'contact', 'appraisedById', true, false, this.vehicle.vehiclePurchase.appraisedBy));
				field_group.addField(new FieldModel('Appraisal Notes', this.vehicle.vehiclePurchase.appraisalNotes, 'longtext', 'appraisalNotes', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Import');
				field_group.addField(new FieldModel('Delivery Port', this.vehicle.vehiclePurchase.deliveryPortId, 'lookup', 'deliveryPortId', true, false, this.vehicle.vehiclePurchase.deliveryPort));
				field_group.addField(new FieldModel('Vessel Name', this.vehicle.vehiclePurchase.vesselName, 'text', 'vesselName', true, false, null));
				field_group.addField(new FieldModel('Voyage', this.vehicle.vehiclePurchase.voyageName, 'text', 'voyageName', true, false, null));
				field_group.addField(new FieldModel('ETD', this.vehicle.vehiclePurchase.vesselDepartDate, 'date', 'vesselDepartDate', true, false, null));
				field_group.addField(new FieldModel('ETA', this.vehicle.vehiclePurchase.portArrivalDate, 'date', 'portArrivalDate', true, false, null));
				field_group.addField(new FieldModel('Date on Yard', this.vehicle.vehiclePurchase.yardArrivalDate, 'date', 'yardArrivalDate', true, false, null));
				field_group.addField(new FieldModel('Country Last Registered', this.vehicle.vehiclePurchase.prevCountryId, 'select', 'prevCountryId', true, false, this.countries));
				field_group.addField(new FieldModel('Year First Registered', this.vehicle.vehiclePurchase.regYear, 'number', 'regYear', true, false, null));
				field_group.addField(new FieldModel('Imported as Damaged Vehicle', this.vehicle.vehiclePurchase.purchaseFlagsImportedAsDamaged, 'toggle', 'purchaseFlagsImportedAsDamaged', true, false, null));
				field_group.addField(new FieldModel('Days Since Purchase', this.vehicle.vehiclePurchase.daysSincePurchase, 'text', 'daysSincePurchase', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Owner History');
				field_group.addField(new FieldModel('Ownership Type', this.vehicle.vehiclePurchase.prevOwnerTypeId, 'lookup', 'prevOwnerTypeId', true, false, this.vehicle.vehiclePurchase.prevOwnerType, '', this.vehicle.vehicleClass));
				var purchaseFlagsIsBrandNew = new FieldModel('Is Brand New', this.vehicle.vehiclePurchase.purchaseFlagsIsBrandNew, 'toggle', 'purchaseFlagsIsBrandNew', true, false, null);
				purchaseFlagsIsBrandNew.hasChildren = true;
				field_group.addField(purchaseFlagsIsBrandNew);
				var prevOwnerNo = new FieldModel('No of Previous Owners', this.vehicle.vehiclePurchase.prevOwnerNo, 'number', 'prevOwnerNo', true, false, null);
				prevOwnerNo.parent = "purchaseFlagsIsBrandNew";
				prevOwnerNo.toggleEditableWhen = "false";
				field_group.addField(prevOwnerNo);
				field_group.addField(new FieldModel('Security Interest Currently Registered on PPSR', this.vehicle.vehiclePurchase.purchaseFlagsHasSecurityInterest, 'toggle', 'purchaseFlagsHasSecurityInterest', true, false, null));
				field_groups.push(field_group);

				break;
			case 'expenses':
				field_group = new FieldGroupModel('Expenses');

				field_groups.push(field_group);
				break;
			case 'exterior':
				field_group = new FieldGroupModel('Exterior');

				this.vehicle.vehicleExterior.extColor1.allowAddCustomField1 = true;
				this.vehicle.vehicleExterior.extColor1.customField1Caption = 'HTML Colour Code';
				let primaryColour = new FieldModel('Primary Colour', this.vehicle.vehicleExterior.extColor1Id, 'lookup', 'extColor1Id', true, false, this.vehicle.vehicleExterior.extColor1, '', this.vehicle.vehicleClass);
				field_group.addField(primaryColour);

				this.vehicle.vehicleExterior.extColor2.allowAddCustomField1 = true;
				this.vehicle.vehicleExterior.extColor2.customField1Caption = 'HTML Colour Code';
				let exteriorColour = new FieldModel('Secondary Colour', this.vehicle.vehicleExterior.extColor2Id, 'lookup', 'extColor2Id', true, false, this.vehicle.vehicleExterior.extColor2, '', this.vehicle.vehicleClass);
				field_group.addField(exteriorColour);

				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Number of Doors', this.vehicle.vehicleExterior.doorNo, 'number', 'doorNo', true, false));
					field_group.addField(new FieldModel('Sunroof', this.vehicle.vehicleExterior.sunroofId, 'lookup', 'sunroofId', true, false, this.vehicle.vehicleExterior.sunroof, '', this.vehicle.vehicleClass));
				}
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Wheels');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Size', this.vehicle.vehicleExterior.wheelSize, 'decimal', 'wheelSize', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Suspension', this.vehicle.vehicleExterior.suspension, 'text', 'suspension', true, false, null));
					field_group.addField(new FieldModel('Brakes', this.vehicle.vehicleExterior.brakes, 'text', 'brakes', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Composition', this.vehicle.vehicleExterior.wheelCompId, 'lookup', 'wheelCompId', true, false, this.vehicle.vehicleExterior.wheelComp, '', this.vehicle.vehicleClass));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle)
				{
					field_group.addField(new FieldModel('Configuration', this.vehicle.vehicleExterior.wheelConfig, 'text', 'wheelConfig', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle)
				{
					field_group.addField(new FieldModel('Tyre Size', this.vehicle.vehicleExterior.tyreConfig, 'text', 'tyreConfig', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Tyres', this.vehicle.vehicleExterior.tyreConfig, 'text', 'tyreConfig', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
					this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Tyre Condition', this.vehicle.vehicleExterior.tyreConditionId, 'lookup', 'tyreConditionId', true, false, this.vehicle.vehicleExterior.tyreCondition, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Other Features');
				field_group.addField(new FieldModel('Other Features', this.vehicle.vehicleExterior.exteriorFeatureIds, 'lookups', 'exteriorFeatureIds', true, false, this.vehicle.vehicleExterior.exteriorFeatureLookups, '', this.vehicle.vehicleClass));
				field_groups.push(field_group);


				break;
			case 'interior':
				field_group = new FieldGroupModel('Interior');
				if (this.vehicle.vehicleClass == VehicleClass.Caravan ||
					this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Machine ||
					this.vehicle.vehicleClass == VehicleClass.Motorhome ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					this.vehicle.vehicleInterior.intColor1.allowAddCustomField1 = true;
					this.vehicle.vehicleInterior.intColor1.customField1Caption = 'Colour';
					let interiorColor = new FieldModel('Interior Colour', this.vehicle.vehicleInterior.intColor1Id, 'lookup', 'intColor1Id', true, false, this.vehicle.vehicleInterior.intColor1, '', this.vehicle.vehicleClass);
					field_group.addField(interiorColor);
				}
				if (this.userService.mcMinVersion("3.2.0"))
				{
					if (this.vehicle.vehicleClass == VehicleClass.Boat)
					{
						field_group.addField(new FieldModel('Number of Berths', this.vehicle.vehicleInterior.berthNo, 'number', 'berthNo', true, false, null));
						field_group.addField(new FieldModel('Number of Cabins', this.vehicle.vehicleInterior.cabinNo, 'number', 'cabins', true, false, null));
					}
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Interior Trim', this.vehicle.vehicleInterior.intTrimId, 'lookup', 'intTrimId', true, false, this.vehicle.vehicleInterior.intTrim, '', this.vehicle.vehicleClass));
					field_group.addField(new FieldModel('Number of Seats', this.vehicle.vehicleInterior.seatNo, 'number', 'seatNo', true, false, null));
					field_group.addField(new FieldModel('Seat Material', this.vehicle.vehicleInterior.seatMaterialId, 'lookup', 'seatMaterialId', true, false, this.vehicle.vehicleInterior.seatMaterial, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Audio');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Cassette Player', this.vehicle.vehicleInterior.audioFlagsCassettePlayer, 'toggle', 'audioFlagsCassettePlayer', true, false, null));
					field_group.addField(new FieldModel('CD Player', this.vehicle.vehicleInterior.audioFlagsCDPlayer, 'toggle', 'audioFlagsCDPlayer', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Motorcycle ||
					this.vehicle.vehicleClass == VehicleClass.Motorhome ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Radio Receiver Capability', this.vehicle.vehicleInterior.audioFlagsBandExpander, 'toggle', 'audioFlagsBandExpander', true, false, null));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Safety');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Number of Airbags', this.vehicle.vehicleInterior.airbagNo, 'number', 'airbagNo', true, false, null));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Berths');
				if (this.vehicle.vehicleClass == VehicleClass.Caravan)
				{
					field_group.addField(new FieldModel('Number of Berths', this.vehicle.vehicleInterior.berthNo, 'number', 'berthNo', true, false, null));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Other Features');
				if (this.vehicle.vehicleClass == VehicleClass.Caravan ||
					this.vehicle.vehicleClass == VehicleClass.Machine ||
					this.vehicle.vehicleClass == VehicleClass.Motorhome ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					field_group.addField(new FieldModel('Other Features', this.vehicle.vehicleInterior.interiorFeatureIds, 'lookups', 'interiorFeatureIds', true, false, this.vehicle.vehicleInterior.interiorFeatureLookups, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				break;
			case 'mechanical':
				field_group = new FieldGroupModel('Engine');
				if (this.vehicle.vehicleClass == VehicleClass.Boat ||
					this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.Machine ||
					this.vehicle.vehicleClass == VehicleClass.Motorcycle ||
					this.vehicle.vehicleClass == VehicleClass.Motorhome ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Engine Size', this.vehicle.vehicleMechanical.engineSize, 'decimal', 'engineSize', true, false, null));
					field_group.addField(new FieldModel('Engine Size Unit', this.vehicle.vehicleMechanical.engineSizeUnitId, 'lookup', 'engineSizeUnitId', true, false, this.vehicle.vehicleMechanical.engineSizeUnit, '', this.vehicle.vehicleClass));
					var engineType = new FieldModel('Engine Type', this.vehicle.vehicleMechanical.engineType1Id, 'lookup', 'engineType1Id', true, false, this.vehicle.vehicleMechanical.engineType1, '', this.vehicle.vehicleClass);
					engineType.hasChildren = true;
					field_group.addField(engineType);

					this.vehicle.vehicleMechanical.transmission.allowAddCustomField1 = true;
					this.vehicle.vehicleMechanical.transmission.customField1Caption = 'Display Short Code';
					let transmission = new FieldModel('Transmission Type', this.vehicle.vehicleMechanical.transmissionId, 'lookup', 'transmissionId', true, false, this.vehicle.vehicleMechanical.transmission, '', this.vehicle.vehicleClass);
					field_group.addField(transmission);

					this.vehicle.vehicleMechanical.fuelType1.allowAddCustomField1 = true;
					this.vehicle.vehicleMechanical.fuelType1.customField1Caption = 'Display Short Code';
					let primaryFuelType = new FieldModel('Primary Fuel Type', this.vehicle.vehicleMechanical.fuelType1Id, 'lookup', 'fuelType1Id', true, false, this.vehicle.vehicleMechanical.fuelType1, '', this.vehicle.vehicleClass);
					field_group.addField(primaryFuelType);

					var secondaryFuelType = new FieldModel('Secondary Fuel Type', this.vehicle.vehicleMechanical.fuelType2Id, 'lookup', 'fuelType2Id', true, false, this.vehicle.vehicleMechanical.fuelType2, '', this.vehicle.vehicleClass);
					secondaryFuelType.parent = 'engineType1Id';
					secondaryFuelType.toggleEditableWhen = 'Hybrid|Plug-In Hybrid'; //Hybrid|Plug-in
					secondaryFuelType.editable = (secondaryFuelType.toggleEditableWhen.indexOf(this.vehicle.vehicleMechanical.engineType1.caption) != -1);
					secondaryFuelType.preventParentIdInLookup = true;


					if (this.editActive || secondaryFuelType.editable)
					{
						field_group.addField(secondaryFuelType);
					}
				}
				if (this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Number of Cylinders', this.vehicle.vehicleMechanical.cylinderNo, 'number', 'cylinderNo', true, false, null));
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Turbo', this.vehicle.vehicleMechanical.turboId, 'lookup', 'turboId', true, false, this.vehicle.vehicleMechanical.turbo, '', this.vehicle.vehicleClass));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorcycle ||
					this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Drive System', this.vehicle.vehicleMechanical.driveSystemId, 'lookup', 'driveSystemId', true, false, this.vehicle.vehicleMechanical.driveSystem, '', this.vehicle.vehicleClass));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Motorcycle)
				{
					field_group.addField(new FieldModel('Exhaust', this.vehicle.vehicleMechanical.exhaustType, 'text', 'exhaustType', true, false));
					field_group.addField(new FieldModel('Engine Description', this.vehicle.vehicleMechanical.engineDescription, 'text', 'engineDescription', true, false));
				}
				if (this.vehicle.vehicleClass == VehicleClass.Boat)
				{
					if (this.userService.mcMinVersion("3.2.0"))
					{
						field_group.addField(new FieldModel('Manufacturer', this.vehicle.vehicleMechanical.engineManuId, 'lookup', 'engineManuId', true, false, this.vehicle.vehicleMechanical.engineManu, '', this.vehicle.vehicleClass));
						field_group.addField(new FieldModel('Model', this.vehicle.vehicleMechanical.engineModel, 'text', 'engineModel', true, false, null));
						field_group.addField(new FieldModel('Engine Year', this.vehicle.vehicleMechanical.engineYear, 'text', 'engineYear', true, false, null));
						field_group.addField(new FieldModel('Engine Hours', this.vehicle.vehicleMechanical.engineHours, 'decimal', 'engineHours', true, false, null));
						field_group.addField(new FieldModel('Drive System', this.vehicle.vehicleMechanical.driveSystemId, 'lookup', 'driveSystemId', true, false, this.vehicle.vehicleMechanical.driveSystem, '', this.vehicle.vehicleClass));
						field_group.addField(new FieldModel('Number of Engines', this.vehicle.vehicleMechanical.engineNo, 'number', 'engineNo', true, false, null));
					}
					else
					{
						field_group.addField(new FieldModel('Engine Hours', this.vehicle.vehicleMechanical.engineHours, 'decimal', 'engineHours', true, false, null));
						field_group.addField(new FieldModel('Engine Year', this.vehicle.vehicleMechanical.engineYear, 'text', 'engineYear', true, false, null));
					}
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle)
				{
					field_group.addField(new FieldModel('Manufacturer', this.vehicle.vehicleMechanical.engineManuId, 'lookup', 'engineManuId', true, false, this.vehicle.vehicleMechanical.engineManu, '', this.vehicle.vehicleClass));
					field_group.addField(new FieldModel('Model', this.vehicle.vehicleMechanical.engineModel, 'text', 'engineModel', true, false, null));
					field_group.addField(new FieldModel('BHP Rating', this.vehicle.vehicleMechanical.engineHp, 'decimal', 'engineHp', true, false, null));
					field_group.addField(new FieldModel('Torque', this.vehicle.vehicleMechanical.engineTorqueId, 'lookup', 'engineTorqueId', true, false, this.vehicle.vehicleMechanical.engineTorque, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				if (this.userService.mcMinVersion("3.2.0"))
				{
					if (this.vehicle.vehicleClass == VehicleClass.Boat)
					{
						field_group = new FieldGroupModel('Ratings');
						field_group.addField(new FieldModel('Max Speed (knots)', this.vehicle.vehicleMechanical.maxSpeed, 'decimal', 'maxSpeed', true, false, null));
						field_group.addField(new FieldModel('Cruise Speed (knots)', this.vehicle.vehicleMechanical.cruiseSpeed, 'decimal', 'cruiseSpeed', true, false, null));
						field_group.addField(new FieldModel('Fuel Capacity (l)', this.vehicle.vehicleMechanical.fuelCapacity, 'decimal', 'fuelCapacity', true, false, null));
						field_group.addField(new FieldModel('Water Capacity (l)', this.vehicle.vehicleMechanical.waterCapacity, 'decimal', 'waterCapacity', true, false, null));
						if (field_group.fields.length) field_groups.push(field_group);
					}
				}

				field_group = new FieldGroupModel('Transmission');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					this.vehicle.vehicleMechanical.transmission.allowAddReference = true;
					this.vehicle.vehicleMechanical.transmission.referenceCaption = 'Display Short Code';

					this.vehicle.vehicleMechanical.transmission.allowAddCustomField1 = true;
					this.vehicle.vehicleMechanical.transmission.customField1Caption = 'Gears';

					let transmission = new FieldModel('Transmission Type', this.vehicle.vehicleMechanical.transmissionId, 'lookup', 'transmissionId', true, false, this.vehicle.vehicleMechanical.transmission, '', this.vehicle.vehicleClass);
					field_group.addField(transmission);
				}
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle)
				{
					field_group.addField(new FieldModel('Model', this.vehicle.vehicleMechanical.transModel, 'text', 'transModel', true, false, null));
					field_group.addField(new FieldModel('Manufacturer', this.vehicle.vehicleMechanical.transManuId, 'lookup', 'transManuId', true, false, this.vehicle.vehicleMechanical.transManu, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				if (this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group = new FieldGroupModel('Electric Battery');
					field_group.addField(new FieldModel('Battery Power (kWh)', this.vehicle.vehicleMechanical.batPower, 'decimal', 'batPower', true, false, null));
					field_group.addField(new FieldModel('Battery Range (km)', this.vehicle.vehicleMechanical.batRange, 'decimal', 'batRange', true, false, null));
					field_group.addField(new FieldModel('SOC/SOH (%)', this.vehicle.vehicleMechanical.batHealth, 'decimal', 'batHealth', true, false, null));
					field_groups.push(field_group);
				}

				field_group = new FieldGroupModel('Odometer');
				if (this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
                    field_group.addField(new FieldModel('Odometer Status', this.vehicle.vehicleMechanical.odoStatusId, 'lookup', 'odoStatusId', true, false, this.vehicle.vehicleMechanical.odoStatus, '', this.vehicle.vehicleClass));

                    if (this.userService.mcMinVersion("3.2.22"))
                    {
                        field_group.addField(new FieldModel('Latest Reading', this.vehicle.vehicleMechanical.latestOdoReadingCaption, 'text', 'lastestOdoReadingCaption', false, false));

                        if (this.userService.mcMinVersion("3.2.23") && this.editActive)
                        {
                            this.vehicle.vehicleMechanical.odoAddReading = false;
                            var addReadingToggle = new FieldModel('Add Odometer Reading', this.vehicle.vehicleMechanical.odoAddReading, 'toggle', 'odoAddReading', true, false, null);
                            addReadingToggle.hasChildren = true;
                            field_group.addField(addReadingToggle);

                            var odoReading = new FieldModel('Odometer Reading', this.vehicle.vehicleMechanical.odoReading, 'decimal', 'odoReading', false, true, null);
                            odoReading.parent = 'odoAddReading';
                            odoReading.toggleEditableWhen = 'true';
                            field_group.addField(odoReading);

                            var odoUnit = new FieldModel('Odo Unit', this.vehicle.vehicleMechanical.odoUnitId, 'lookup', 'odoUnitId', false, true, this.vehicle.vehicleMechanical.odoUnit, '', this.vehicle.vehicleClass);
                            odoUnit.parent = 'odoAddReading';
                            odoUnit.toggleEditableWhen = 'true';
                            field_group.addField(odoUnit);

                            var odoDate = new FieldModel('Odometer Reading Date', this.vehicle.vehicleMechanical.odoDate, 'date', 'odoDate', false, true, null);
                            odoDate.parent = 'odoAddReading';
                            odoDate.toggleEditableWhen = 'true';
                            field_group.addField(odoDate);
                        }

                        if (!this.editActive)
                        {
                            var odoHistory = new FieldModel('View odometer history', '', 'button', 'viewOdometerHistory', false, false, null, "button-price-history");
                            odoHistory.buttonExpand = 'block';
                            odoHistory.buttonSize = 'small';
                            field_group.addField(odoHistory);
                        }
                    }
                    else
                    {
                        //Deprecated - remove in the future
                        field_group.addField(new FieldModel('Odometer Reading', this.vehicle.vehicleMechanical.odoReading, 'decimal', 'odoReading', true, false, null));
                        if (this.userService.mcMinVersion("3.2.2"))
                        {
                        	field_group.addField(new FieldModel('Odo Unit', this.vehicle.vehicleMechanical.odoUnitId, 'lookup', 'odoUnitId', true, false, this.vehicle.vehicleMechanical.odoUnit, '', this.vehicle.vehicleClass));
                        }
                        field_group.addField(new FieldModel('Odometer Reading Date', this.vehicle.vehicleMechanical.odoDate, 'date', 'odoDate', true, false, null));
                    }
                }
				if (this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('Odometer Certified', this.vehicle.vehicleMechanical.mechanicalFlagsOdometerCertified, 'toggle', 'mechanicalFlagsOdometerCertified', true, false, null));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Safety');
				if (this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					field_group.addField(new FieldModel('ABS Braking', this.vehicle.vehicleMechanical.mechanicalFlagsABSBraking, 'toggle', 'mechanicalFlagsABSBraking', true, false, null));
					field_group.addField(new FieldModel('Traction Control', this.vehicle.vehicleMechanical.mechanicalFlagsTractionControl, 'toggle', 'mechanicalFlagsTractionControl', true, false, null, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				field_group = new FieldGroupModel('Other Features');
				if (this.vehicle.vehicleClass == VehicleClass.Boat || this.vehicle.vehicleClass == VehicleClass.GoodsVehicle || this.vehicle.vehicleClass == VehicleClass.Machine || this.vehicle.vehicleClass == VehicleClass.Motorcycle || this.vehicle.vehicleClass == VehicleClass.Motorhome || this.vehicle.vehicleClass == VehicleClass.PassengerVehicle)
				{
					var lookupModel = new LookupModel();
					lookupModel.collection = "VehicleMechanicalFeatures";
					lookupModel.lookupType = "external";
					field_group.addField(new FieldModel('Other Features', this.vehicle.vehicleMechanical.mechanicalFeatureIds, 'lookups', 'mechanicalFeatureIds', true, false, this.vehicle.vehicleMechanical.mechanicalFeatureLookups, '', this.vehicle.vehicleClass));
				}
				if (field_group.fields.length) field_groups.push(field_group);

				break;
			case 'export':
				field_group = new FieldGroupModel('Export Settings');
				var adminFlagsIncludeExport = new FieldModel('Include in All Exports', this.vehicle.vehicleExport.adminFlagsIncludeExport, 'toggle', 'adminFlagsIncludeExport', true, false, null);
				adminFlagsIncludeExport.hasChildren = true;
				field_group.addField(adminFlagsIncludeExport);

				if (this.editActive || this.vehicle.vehicleExport.adminFlagsIncludeExport == false)
				{
					var exportSpecs = new FieldModel('Specify Exports where this Vehicle is included', this.vehicle.vehicleExport.exportSpecIds, 'selects', 'exportSpecIds', this.vehicle.vehicleExport.adminFlagsIncludeExport == false, false, this.exportSpecsNonAuction, '', this.vehicle.vehicleClass)
					exportSpecs.parent = 'adminFlagsIncludeExport';
					exportSpecs.toggleEditableWhen = 'false';
					field_group.addField(exportSpecs);
				}

				field_groups.push(field_group);

				field_group = new FieldGroupModel('Need a Car');
				field_group.addField(new FieldModel('Highlight this Vehicle', this.vehicle.vehicleExport.adminFlagsIsFeaturedNeedacar, 'toggle', 'adminFlagsIsFeaturedNeedacar', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Trade Me');
				field_group.addField(new FieldModel('Feature this Vehicle', this.vehicle.vehicleExport.adminFlagsIsFeatured, 'toggle', 'adminFlagsIsFeatured', true, false, null));
				field_group.addField(new FieldModel('Top Pick this Vehicle', this.vehicle.vehicleExport.adminFlagsIsShowroomTradeMe, 'toggle', 'adminFlagsIsShowroomTradeMe', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Export Vehicle as an Auction');
				var chkAuctionExport = new FieldModel('Export this vehicle as an Auction', this.vehicle.vehicleExport.chkAuctionExport, 'toggle', 'chkAuctionExport', true, false, null);
				chkAuctionExport.hasChildren = true;
				field_group.addField(chkAuctionExport);

				if (this.editActive || this.vehicle.vehicleExport.chkAuctionExport)
				{
					var auctionExportId = new FieldModel('Export as an Auction to', this.vehicle.vehicleExport.auctionExportId, 'select', 'auctionExportId', this.vehicle.vehicleExport.chkAuctionExport, false, this.exportSpecsAuction);
					auctionExportId.parent = 'chkAuctionExport';
					auctionExportId.toggleEditableWhen = 'true';
					field_group.addField(auctionExportId);
				}

				field_group.addField(new FieldModel('Start Price', this.vehicle.vehicleExport.startPriceAmount, 'currency', 'startPriceAmount', true, false, null));
				field_group.addField(new FieldModel('Reserve', this.vehicle.vehicleExport.reservePriceAmount, 'currency', 'reservePriceAmount', true, false, null));
				field_group.addField(new FieldModel('Now', this.vehicle.vehicleExport.buyNowPriceAmount, 'currency', 'buyNowPriceAmount', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Additional Export Information');
				field_group.addField(new FieldModel('Title', this.vehicle.vehicleExport.exportTitle, 'text', 'exportTitle', true, false, null));
				field_group.addField(new FieldModel('Tagline / Subtitle', this.vehicle.vehicleExport.exportTagline, 'text', 'exportTagline', true, false, null));
				field_group.addField(new FieldModel('Alternate Variant', this.vehicle.vehicleExport.variantAlt, 'text', 'variantAlt', true, false, null));
				// field_group.addField(new FieldModel('Alternate Variant', this.vehicle.vehicleExport.variantAlt, 'text', 'variantAlt', true, false, null));
                field_group.addField(new FieldModel('Alternate Stock No', this.vehicle.vehicleExport.stockNoAlt, 'text', 'stockNoAlt', true, false, null));

                if (this.userService.mcMinVersion("3.2.23") && !this.editActive)
                {
                    var altStockNoButton = new FieldModel('Change alternate stock no', '', 'button', 'alternateStockNumberChange', false, false, null, "button-alternate-stock-number");
                    altStockNoButton.buttonExpand = 'block';
                    altStockNoButton.buttonSize = 'small';
                    field_group.addField(altStockNoButton);
                }

                if (this.userService.mcMinVersion("3.2.24"))
                {
                    field_group.addField(new FieldModel('Consumer Information Notice not required for this vehicle', this.vehicle.vehicleExport.adminFlagsIsCINExcluded, 'toggle', 'adminFlagsIsCINExcluded', true, false, null));
                }

                field_groups.push(field_group);

                field_group = new FieldGroupModel('Description');
                if (this.userService.mcMinVersion("3.2.23") && this.editActive)
                {
                    field_group.editLink = true;
                }
				field_group.addField(new FieldModel('Details / Comments', this.vehicle.vehicleExport.exportDescription, 'longtext', 'exportDescription', true, false, null));

                if (!this.editActive && this.userService.mcMinVersion("3.2.22") && this.vehicle.vehicleExport.aiQualified)
                {
                    var odoHistory = new FieldModel('AI generator', '', 'button', 'aiDescriptionGenerator', false, false, null, "button-ai-generator");
                    odoHistory.buttonExpand = 'block';
                    odoHistory.buttonSize = 'small';
                    field_group.addField(odoHistory);
                }

				field_groups.push(field_group);

                var field_group = new FieldGroupModel('Vehicle Offer');

				this.populateVehicleOfferFields(this.vehicle, field_group);

                if (!this.editActive && this.userService.mcMinVersion("3.2.22"))
                {
                    var vehicleOffers = new FieldModel('View vehicle offers', '', 'button', 'viewVehicleOffers', false, false, null, "button-vehicle-offers");
                    vehicleOffers.buttonExpand = 'block';
                    vehicleOffers.buttonSize = 'small';
                    field_group.addField(vehicleOffers);
                }

				field_groups.push(field_group);

				break;
			case 'admin':
				field_group = new FieldGroupModel('Current Status');
				var statusSelector = new FieldModel('Status', this.vehicle.vehicleAdmin.vehicleStatusId, 'lookup', 'vehicleStatusId', true, false, this.vehicle.vehicleAdmin.vehicleStatus, '', this.vehicle.vehicleClass);
				statusSelector.showBoxes = true;
				statusSelector.hasChildren = true;
				field_group.addField(statusSelector);

				var vehicleStatusSupId = new FieldModel('Supplier', this.vehicle.vehicleAdmin.vehicleStatusSupId, 'contact', 'vehicleStatusSupId', true, false, this.vehicle.vehicleAdmin.vehicleStatusSup);
				vehicleStatusSupId.parent = 'vehicleStatusId';
				vehicleStatusSupId.toggleEditableWhen = "0cc33a04-ed83-4363-ad2b-1f1f988d4ef9";
				vehicleStatusSupId.editable = (this.vehicle.vehicleAdmin.vehicleStatusId == "0cc33a04-ed83-4363-ad2b-1f1f988d4ef9");


				var vehicleStatusDesc = new FieldModel('Status Comment', this.vehicle.vehicleAdmin.vehicleStatusDesc, 'longtext', 'vehicleStatusDesc', true, false, null);
				vehicleStatusDesc.parent = 'vehicleStatusId';
				vehicleStatusDesc.toggleEditableWhen = "0cc33a04-ed83-4363-ad2b-1f1f988d4ef9";
				vehicleStatusDesc.editable = (this.vehicle.vehicleAdmin.vehicleStatusId != "0cc33a04-ed83-4363-ad2b-1f1f988d4ef9");
				vehicleStatusDesc.inverseCheck = true;

				if (this.editActive || vehicleStatusSupId.editable)
				{
					field_group.addField(vehicleStatusSupId);
				}
				if (this.editActive || vehicleStatusDesc.editable)
				{
					field_group.addField(vehicleStatusDesc);
				}

				if (this.userService.mcMinVersion("3.2.19") && !this.editActive)
				{
					var statusHistory = new FieldModel('View status history', '', 'button', 'viewStatusHistory', false, false, null, "button-status-history");
					statusHistory.buttonExpand = 'block';
					statusHistory.buttonSize = 'small';
					field_group.addField(statusHistory);
				}

				field_groups.push(field_group);

				if (this.userService.mcMinVersion("3.2.19") && !this.editActive)
				{
				    field_group = new FieldGroupModel('Dealership');
				    field_group.addField(new FieldModel('Owner Dealership', this.vehicle.vehicleAdmin.companyId, 'contact', 'companyId', true, false, this.vehicle.vehicleAdmin.company));

                    if (this.userService.mcMinVersion("3.2.21"))
                    {
                        var transferVehicle = new FieldModel('Transfer vehicle', '', 'button', 'transferVehicle', false, false, null, "button-transfer-vehicle");
                        transferVehicle.buttonExpand = 'block';
                        transferVehicle.buttonSize = 'small';
                        field_group.addField(transferVehicle);
                    }

					var transferHistory = new FieldModel('View transfer history', '', 'button', 'viewTransferHistory', false, false, null, "button-transfer-history");
					transferHistory.buttonExpand = 'block';
					transferHistory.buttonSize = 'small';
					field_group.addField(transferHistory);
                    
                    field_groups.push(field_group);
				}

				field_group = new FieldGroupModel('Licensing');
				field_group.addField(new FieldModel('Licensing Expiry Date', this.vehicle.vehicleAdmin.regExpiryDate, 'date', 'regExpiryDate', true, false, null));
				var adminFlagsRoadUserChargesApply = new FieldModel('Road User Charges Apply', this.vehicle.vehicleAdmin.adminFlagsRoadUserChargesApply, 'toggle', 'adminFlagsRoadUserChargesApply', true, false, null, null)
				adminFlagsRoadUserChargesApply.hasChildren = true;
				field_group.addField(adminFlagsRoadUserChargesApply);

				var adminFlagsRoadUserChargesOutstanding = new FieldModel('Outstanding Road User charges', this.vehicle.vehicleAdmin.adminFlagsRoadUserChargesOutstanding, 'toggle', 'adminFlagsRoadUserChargesOutstanding', true, false, null)
				adminFlagsRoadUserChargesOutstanding.parent = "adminFlagsRoadUserChargesApply";
				adminFlagsRoadUserChargesOutstanding.toggleEditableWhen = "true;"
				field_group.addField(adminFlagsRoadUserChargesOutstanding);

				var roadUserEnd = new FieldModel('RUC End Distance', this.vehicle.vehicleAdmin.roadUserEnd, 'number', 'roadUserEnd', true, false, null);
				roadUserEnd.parent = 'adminFlagsRoadUserChargesApply';
				roadUserEnd.toggleEditableWhen = "true";
				field_group.addField(roadUserEnd);

				field_group.addField(new FieldModel('WOF/COF Expiry Date', this.vehicle.vehicleAdmin.cofExpiryDate, 'date', 'cofExpiryDate', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Notes');
				field_group.addField(new FieldModel('Notes', this.vehicle.vehicleAdmin.comment, 'longtext', 'comment', true, false, null));
				field_groups.push(field_group);

				field_group = new FieldGroupModel('Pricing');

                field_group = this.populateVehiclePriceFields(this.vehicle, field_group);

				if (this.userService.mcMinVersion("3.2.19") && !this.editActive)
				{
					var priceHistory = new FieldModel('View pricing history', '', 'button', 'viewPriceHistory', false, false, null, "button-price-history");
					priceHistory.buttonExpand = 'block';
					priceHistory.buttonSize = 'small';
					field_group.addField(priceHistory);
				}

				field_groups.push(field_group);

				// console.log(field_groups)


				if (!this.editActive &&
					this.vehicle.vehicleGeneral.fuelSaverResult.reference &&
					this.userService.mcMinVersion("3.2.11"))
				{
					field_group = new FieldGroupModel('Clean Car Details');


					var rebateText = "";
					switch (this.vehicle.vehicleGeneral.fuelSaverResult.cleanVehicleInd)
					{

						case "Not eligible":
						case "No rebate or Fee":
							rebateText = this.vehicle.vehicleGeneral.fuelSaverResult.cO2Disclaimer;
							break;
						case "Possible Fee":
						case "Fee":
						case "Possible Rebate":
						case "Rebate":
							rebateText = this.vehicle.vehicleGeneral.fuelSaverResult.cleanVehicleText;
							break;
					}

					field_group.addField(new FieldModel('Clean Car Fee/Rebate', rebateText, 'text', 'rebateText', true, false, null));
					// field_group.addField(new FieldModel('Amount', this.numberWithCommas(this.vehicle.vehicleGeneral.fuelSaverResult.cleanVehicleAmount), 'currency',  null, true, false, null));
					// field_group.addField(new FieldModel('Amount Max', this.numberWithCommas(this.vehicle.vehicleGeneral.fuelSaverResult.cleanVehicleAmountMax), 'currency',  null, true, false, null));
					// field_group.addField(new FieldModel('Amount Max', this.numberWithCommas(this.vehicle.vehicleAdmin), 'currency',  null, true, false, null));
					field_groups.push(field_group);
				}

				field_group = new FieldGroupModel('Vehicle Groups');
				var adminFlagsIncludeGroups = new FieldModel('Include in All Groups', this.vehicle.vehicleAdmin.adminFlagsIncludeGroups, 'toggle', 'adminFlagsIncludeGroups', true, false, null)
				adminFlagsIncludeGroups.hasChildren = true;
				field_group.addField(adminFlagsIncludeGroups);

                //only show the vehicle groups if not included in all groups
                if (this.userService.mcMinVersion("3.2.22"))
				{
					var vehicleGroupIds = new FieldModel('Specify groups where this vehicle is included', this.vehicle.vehicleAdmin.vehicleGroupIds, 'lookups', 'vehicleGroupIds', true, false, this.vehicle.vehicleAdmin.vehicleGroups, '', this.vehicle.vehicleClass);
					vehicleGroupIds.parent = 'adminFlagsIncludeGroups';
					vehicleGroupIds.toggleEditableWhen = 'false';
					vehicleGroupIds.editable = (this.vehicle.vehicleAdmin.adminFlagsIncludeGroups == false);
					field_group.addField(vehicleGroupIds);
				}
				field_groups.push(field_group);

				break;

			case 'images':
				field_group = new FieldGroupModel('Image Overlays');

				var firstImage = new FieldModel('First Image', this.vehicle.vehicleImages.overlay1Id, 'lookup', 'overlay1Id', true, false, this.vehicle.vehicleImages.overlay1, '', this.vehicle.vehicleClass);
				firstImage.showBoxes = true;
				firstImage.hasChildren = true;
				field_group.addField(firstImage);

				var otherImages = new FieldModel('Other Images', this.vehicle.vehicleImages.overlay2Id, 'lookup', 'overlay2Id', true, false, this.vehicle.vehicleImages.overlay2, '', this.vehicle.vehicleClass);
				otherImages.showBoxes = true;
				otherImages.hasChildren = true;
				field_group.addField(otherImages);

				//add a link
				var imageOverlayLink = new FieldModel('', 'About image overlays', 'url', 'overlayLink', true, false, 'https://support.motorcentral.co.nz/hc/en-us/articles/213883163-Using-Vehicle-Image-Overlays', '', '', true);
				imageOverlayLink.hideLabel = true;
				field_group.addField(imageOverlayLink);

				field_groups.push(field_group);

				field_group = new FieldGroupModel('Videos');
				var youtubeId = new FieldModel('YouTube Video ID', this.vehicle.vehicleImages.youTubeId, 'text', 'youTubeId', true, false, null)
				if (this.editActive)
				{
					youtubeId.hasButton = true;
					youtubeId.buttonText = "Preview";
					youtubeId.buttonIonIcon = "open-outline";
					youtubeId.buttonName = "button-youtube";
					youtubeId.launchOnLoad = true;
				}
				else if (this.vehicle.vehicleImages.youTubeId)
				{
					//show a link
					var url = "https://youtu.be/" + encodeURIComponent(this.vehicle.vehicleImages.youTubeId);
					youtubeId = new FieldModel("YouTube Video", url, "url", "youTubeId", false, false, null, '', '', true);
				}
				field_group.addField(youtubeId);

				field_groups.push(field_group);

				break;
			case 'custom':
				field_group = new FieldGroupModel("Custom Fields");
				field_group.singleColumn = true;
				for (let i = 1; i <= 12; i++)
				{
					const customFieldDisplayModel = CustomFieldDisplayModel.fromDto(this.vehicle.vehicleCustomFields[`customField${i}_Object`]);
					if (customFieldDisplayModel.visible)
					{
						const customFieldValue = this.vehicle.vehicleCustomFields[`customField${i}`];
						field_group.addField(new FieldModel(customFieldDisplayModel.name, customFieldValue, customFieldDisplayModel.fieldModelType, `customField${i}`, true, false, customFieldDisplayModel.dropdownOptions));
					}
				}
				field_groups.push(field_group);
				break;
		}
		return field_groups;
	}

    populateVehiclePriceFields(vehicle: VehicleModel, field_group: FieldGroupModel, readOnlyProperties: ExternalProcessorControlledField[] = null): FieldGroupModel
    {

        var retailPriceObject = new PriceEditorModel();
        retailPriceObject.price = { id: "retailPriceAmount", value: vehicle.vehicleAdmin.retailPriceAmount };
        retailPriceObject.taxType = { id: "retailPriceTaxStatusEnum", value: vehicle.vehicleAdmin.retailPriceTaxStatusEnum };
        if (this.userService.mcMinVersion("3.2.22"))
        {
            retailPriceObject.mode = "extended";
            retailPriceObject.editableTaxRate = false;
            retailPriceObject.currency = { id: "retailPriceCurrencyId", value: "" };
            retailPriceObject.taxRate = { id: "priceTaxRate", value: vehicle.vehicleAdmin.priceTaxRate };
            retailPriceObject.taxAmount = { id: "retailPriceTaxAmount", value: vehicle.vehicleAdmin.retailPriceTaxAmount };
        }

        var retailIncludesAnyReadOnly = readOnlyProperties?.some(field =>
            field === ExternalProcessorControlledField.RetailPriceAmount ||
            field === ExternalProcessorControlledField.RetailPriceTaxStatusEnum ||
            field === ExternalProcessorControlledField.PriceTaxRate ||
            field === ExternalProcessorControlledField.RetailPriceTaxAmount
        );
        field_group.addField(new FieldModel("Retail price", vehicle.vehicleAdmin.retailPriceAmount, "price", "retailPriceAmount", !retailIncludesAnyReadOnly, false, retailPriceObject, null, null, true));

        var wholesalePriceObject = new PriceEditorModel();
        wholesalePriceObject.price = { id: "wholesalePriceAmount", value: vehicle.vehicleAdmin.wholesalePriceAmount };
        wholesalePriceObject.taxType = { id: "wholesalePriceTaxStatusEnum", value: vehicle.vehicleAdmin.wholesalePriceTaxStatusEnum };
        if (this.userService.mcMinVersion("3.2.22"))
        {
            wholesalePriceObject.mode = "extended";
            wholesalePriceObject.editableTaxRate = false;
            wholesalePriceObject.currency = { id: "wholesalePriceCurrencyId", value: "" };
            wholesalePriceObject.taxRate = { id: "priceTaxRate", value: vehicle.vehicleAdmin.priceTaxRate };
            wholesalePriceObject.taxAmount = { id: "wholesalePriceTaxAmount", value: vehicle.vehicleAdmin.wholesalePriceTaxAmount };
        }
        var wholesaleIncludesAnyReadOnly = readOnlyProperties?.some(field =>
            field === ExternalProcessorControlledField.WholesalePrice ||
            field === ExternalProcessorControlledField.WholesalePriceTaxStatusEnum ||
            field === ExternalProcessorControlledField.PriceTaxRate ||
            field === ExternalProcessorControlledField.WholesalePriceTaxAmount
        );
        field_group.addField(new FieldModel("Wholesale price", vehicle.vehicleAdmin.wholesalePriceAmount, "price", "wholesalePriceAmount", !wholesaleIncludesAnyReadOnly, false, wholesalePriceObject, null, null, true));

        var specialPriceObject = new PriceEditorModel();
        specialPriceObject.price = { id: "specialPriceAmount", value: vehicle.vehicleAdmin.specialPriceAmount };
        specialPriceObject.taxType = { id: "specialPriceTaxStatusEnum", value: vehicle.vehicleAdmin.specialPriceTaxStatusEnum };
        if (this.userService.mcMinVersion("3.2.22"))
        {
            specialPriceObject.mode = "extended";
            specialPriceObject.editableTaxRate = false;
            specialPriceObject.currency = { id: "specialPriceCurrencyId", value: "" };
            specialPriceObject.taxRate = { id: "priceTaxRate", value: vehicle.vehicleAdmin.priceTaxRate };
            specialPriceObject.taxAmount = { id: "specialPriceTaxAmount", value: vehicle.vehicleAdmin.specialPriceTaxAmount };
        }
        var specialPriceIncludesAnyReadOnly = readOnlyProperties?.some(field =>
            field === ExternalProcessorControlledField.OtherPrice1Amount ||
            field === ExternalProcessorControlledField.OtherPrice1TaxStatusEnum ||
            field === ExternalProcessorControlledField.PriceTaxRate ||
            field === ExternalProcessorControlledField.OtherPrice1TaxAmount
        );
        field_group.addField(new FieldModel("Special price", vehicle.vehicleAdmin.specialPriceAmount, "price", "specialPriceAmount", !specialPriceIncludesAnyReadOnly, false, specialPriceObject, null, null, true));

        var orcPriceObject = new PriceEditorModel();
        orcPriceObject.price = { id: "orcPriceAmount", value: vehicle.vehicleAdmin.orcPriceAmount };
        orcPriceObject.taxType = { id: "orcPriceTaxStatusEnum", value: vehicle.vehicleAdmin.orcPriceTaxStatusEnum };
        if (this.userService.mcMinVersion("3.2.22"))
        {
            orcPriceObject.mode = "extended";
            orcPriceObject.currency = { id: "orcPriceCurrencyId", value: "" };
            orcPriceObject.editableTaxRate = false;
            orcPriceObject.taxRate = { id: "priceTaxRate", value: vehicle.vehicleAdmin.priceTaxRate };
            orcPriceObject.taxAmount = { id: "orcPriceTaxAmount", value: vehicle.vehicleAdmin.orcPriceTaxAmount };
        }
        var orcPriceIncludesAnyReadOnly = readOnlyProperties?.some(field =>
            field === ExternalProcessorControlledField.OtherPrice2Amount ||
            field === ExternalProcessorControlledField.OtherPrice2TaxStatusEnum ||
            field === ExternalProcessorControlledField.PriceTaxRate ||
            field === ExternalProcessorControlledField.OtherPrice2TaxAmount
        );
        field_group.addField(new FieldModel("On road costs", vehicle.vehicleAdmin.orcPriceAmount, "price", "orcPriceAmount", !orcPriceIncludesAnyReadOnly, false, orcPriceObject, null, null, true));

        field_group.addField(new FieldModel('Don\'t Promote Finance on this Vehicle', vehicle.vehicleAdmin.adminFlagsDisableFinance, 'toggle', 'adminFlagsDisableFinance', !readOnlyProperties?.includes(ExternalProcessorControlledField.AdminFlagsDisableFinance), false, null, null, null, true));

        return field_group

    }

    public setupExpenseSummaryFields(gstTitle: string = "inclusive")
    {
        var field_groups: FieldGroupModel[] = [];

        var field_group = new FieldGroupModel('Expense summary (GST ' + gstTitle + ')');
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        const expense = this.vehicle.vehicleExpenses
        this.addCurrencyField(field_group, new FieldModel("Import costs", expense.summaryPurchaseCostsImportAmount, "currency"), "nounderline");
        this.addCurrencyField(field_group, new FieldModel("Local costs", expense.summaryPurchaseCostsLocalAmount, "currency"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Purchase costs", expense.summaryPurchaseCostsLocalAmount, "currency"), "bold nounderline");
        this.addCurrencyField(field_group, new FieldModel("(GST)", expense.summaryPurchaseCostsLocalTaxAmount, "currency", "sami-look-here"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Exact expenses", expense.summaryStandardExpenseAmountExact, "currency"), "nounderline");
        this.addCurrencyField(field_group, new FieldModel("Estimated expenses", expense.summaryStandardExpenseAmountEstimate, "currency"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Total expenses", expense.summaryStandardExpenseAmount, "currency"), "bold nounderline");
        this.addCurrencyField(field_group, new FieldModel("(GST)", expense.summaryStandardExpenseTaxAmount, "currency"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Total", expense.summaryTotalCostsAmount, "currency"), "bold nounderline");
        this.addCurrencyField(field_group, new FieldModel("(GST)", expense.summaryTotalCostsTaxAmount, "currency"), "nounderline");
        field_groups.push(field_group);



        field_group = new FieldGroupModel("Margin summary");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        var isSold = this.vehicle.vehicleAdmin.vehicleStatus != null && this.vehicle.vehicleAdmin.vehicleStatus.member == VehicleStatusEnum.Sold;
        if (isSold)
        {
            this.addCurrencyField(field_group, new FieldModel("Sold price", expense.summaryGrossPriceAmountCaption, "text"), "nounderline");
        }
        else
        {
            this.addCurrencyField(field_group, new FieldModel("Retail price", expense.summaryGrossPriceAmountCaption, "text"), "nounderline");
        }
        this.addCurrencyField(field_group, new FieldModel("Gross profit", expense.summaryGrossProfitAmountCaption, "text"), "nounderline");
        this.addCurrencyField(field_group, new FieldModel("GST payable", expense.summaryGrossProfitTaxAmountCaption, "text"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Appraisal", this.vehicle.vehiclePurchase.appraisalAmountCaption + "incl", "text"), "nounderline");
        this.addCurrencyField(field_group, new FieldModel("Appraised by", this.vehicle.vehiclePurchase.appraisedBy.displayName || '-', "text"), "underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("Net profit",  expense.summaryNetProfitAmountCaption, "text"), "bold nounderline");
        this.addCurrencyField(field_group, new FieldModel("Net margin", expense.summaryNetProfitPercentCaption, "text"), "bold underline");
        field_groups.push(field_group);

        field_group = new FieldGroupModel("");
        field_group.classes = "nogreyborder";
        field_group.singleColumn = true;
        this.addCurrencyField(field_group, new FieldModel("After-sale costs", expense.summaryAfterSaleExpenseAmountCaption, "text"), "nounderline");
        field_groups.push(field_group);

        return field_groups;
    }

    public addCurrencyField(group: FieldGroupModel, field: FieldModel, extraclass: string = "")
	{
		if (!field.value)
		{
			field.value = "0";
		}
		group.addField(this.getCurrencyField(field, extraclass));
		// }
	}

    public getCurrencyField(field: FieldModel, extraclass: string = "")
	{
		field.oneline = true;
		field.classes = "compactrow dollar zeros " + extraclass;
		return field;
	}

    populateVehicleOfferFields(vehicle: VehicleModel, field_group: FieldGroupModel): FieldGroupModel
    {
        var displayOffer = new FieldModel('Display an offer on this vehicle', vehicle.vehicleExport.displayOffer, 'toggle', 'displayOffer', true, false, null);
        displayOffer.hasChildren = true;
        field_group.addField(displayOffer);

        var expiryDate = new FieldModel('Expiry Date', vehicle.vehicleExport.offerEndDate, 'date', 'offerEndDate', true, true, null);
        expiryDate.parent = 'displayOffer';
        expiryDate.toggleEditableWhen = 'true';
        expiryDate.editable = (vehicle.vehicleExport.displayOffer == true);
        field_group.addField(expiryDate);

        var offerText = new FieldModel('Offer Text', vehicle.vehicleExport.offerText, 'text', 'offerText', true, true, null);
        offerText.parent = 'displayOffer';
        offerText.toggleEditableWhen = 'true';
        offerText.editable = (vehicle.vehicleExport.displayOffer == true);
        field_group.addField(offerText);

        return field_group;
    }

	public numberWithCommas(x: any): string
	{
		if (x == null) return;
		var parts = x.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}

	getVehicleQuickLookup(plateOrVin: string): Observable<VehicleCheckVehicle>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('plateOrVin', plateOrVin);
		return this.httpClient.get<VehicleCheckVehicle>(Constants.ApiUrl + 'vehicleChecks/VehicleQuickLookup', { params: httpParams });
	}


	public countries: ListItemModel[];
	protected getLookups(): void
	{
		this.generalService.getCachedCountries().subscribe(x => { this.countries = x.map(y => new ListItemModel(y.countryId.toString(), y.name)); });
	}

	public getVehicleDocuments(saleId: string): Observable<DocumentModel[]>
	{
		return this.httpClient.get<DocumentModel[]>(Constants.ApiUrl + 'Vehicles/' + saleId + "/Documents");
	}

	public getVehicleDocument(id: string, documentURI: string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get(Constants.ApiUrl + 'Vehicles/' + id + "/Document", { params: httpParams, responseType: "blob" });
	}

	public getVehicleDocumentUrl(id: string, documentURI: string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get<string>(Constants.ApiUrl + 'Vehicles/' + id + "/DocumentUrl", { params: httpParams });
	}

	public retrieveFuelSaver(vehicleId: string): Observable<VehicleModel>
	{
		return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/FuelSaver', '');
	}

	listDealerships: ListItemModel[];
	async newVehicleModal(vehicleClass: string, openEdit: boolean = true): Promise<any>
	{
		return new Promise((resolve, reject) =>
		{
			this.userService.getCurrentUser().subscribe({ next: async x =>
			{
				var currentUser = x;

				this.contactService.getDealerships(false).subscribe({ next: async x =>
				{
					this.listDealerships = x.map<ListItemModel>(y => new ListItemModel(y.id, y.name));

					var newVehicle = {
						regNo: "",
						vin: "",
						chassis: "",
						vehicleClass: vehicleClass,
						carCheckType: "basic",
						dealershipId: currentUser.ownerCompanyId
					}

					var create_vehicle_fields: FieldGroupModel[] = [];
					var typeLabel = vehicleClass;
					switch (vehicleClass)
					{
						case "PassengerVehicle":
							typeLabel = "Passenger Vehicle";
							break;
						case "GoodsVehicle":
							typeLabel = "Goods Vehicle";
							break;
					}
					var group_1 = new FieldGroupModel("Add " + typeLabel);
					group_1.addField(new FieldModel("Registration or Vin", newVehicle.regNo, "text", "regNo", true, false));
					group_1.addField(new FieldModel('Owner Dealership', newVehicle.dealershipId, 'select', 'dealershipId', true, false, this.listDealerships));

					create_vehicle_fields.push(group_1);

					const modal = await this.modalController.create({
						component: ModalDetailsEditComponent,
						componentProps: {
							'title': 'Add New Vehicle',
							'edit': true,
							'field_groups': create_vehicle_fields,
							'isDirty': false
						}
					});
					await modal.present();
					const { data } = await modal.onDidDismiss();

					if (data && data.result && data.result.save)
					{
						if (openEdit)
						{
							this.syncFormWithObject(newVehicle, create_vehicle_fields);
							var url = "/vehicles/new/details/" + vehicleClass + "/" + newVehicle.dealershipId + "/" + newVehicle.regNo;
							this.navCtrl.navigateForward(url);
							resolve(newVehicle);
						} else
						{
							this.syncFormWithObject(newVehicle, create_vehicle_fields);
							resolve(newVehicle);
						}
					} else
					{
						// console.log("New vehicle cancelled");
						reject("New vehicle cancelled");
					}
				}, error: error =>
				{
					reject(error);
				}});
			}, error: error =>
			{
				reject(error);
			}});
		});
	}


	public syncFormWithObject(data: any, fieldGroups: FieldGroupModel[]): any
	{
		var data_changed = false;

		for (let field_group of fieldGroups)
		{
			for (let field of field_group.fields)
			{
				// console.log(data[field.id]);
				if (data[field.id] != null && data[field.id] != field.value && !field.invalid && field.dirty)
				{
					data_changed = true;
					data[field.id] = field.value;
				}
			}
		}
		return data;
	}

	async saveRecentVehicle(vehicle: VehicleSummaryModel)
	{
		console.debug("saveRecentVehicle", vehicle);
		var val = await this.storage.get(Constants.IonicStorage_RecentVehicles);

		var recentVehicles = [];
		if (val)
		{
			recentVehicles = JSON.parse(val);
			if (!Array.isArray(recentVehicles))
			{
				recentVehicles = [];
			}
			else
			{
				recentVehicles = recentVehicles.filter(item => item.stockNo !== vehicle.stockNo); //remove vehicle if it is there already
			}
		}

		recentVehicles.unshift(vehicle);

		if (recentVehicles.length > 20)
		{
			recentVehicles = recentVehicles.slice(0, 20);
		}

		await this.storage.set(Constants.IonicStorage_RecentVehicles, JSON.stringify(recentVehicles));
		// console.log('set recent vehicles', recentVehicles);
		localStorage.setItem('recent-vehicles-initialised', 'true');
	}

	updateVehicleDealership(vehicleId: string, dealershipId: string, transferDate: string): Observable<VehicleAdminModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('transferDate', transferDate);
		return this.httpClient.patch<VehicleAdminModel>(`${Constants.ApiUrl}vehicles/${vehicleId}/Dealership/${dealershipId}`, httpParams);
	}


	async removeRecentVehicle(vehicleId: string)
	{
		var val = await this.storage.get(Constants.IonicStorage_RecentVehicles);

		var recentVehicles = [];

		//remove vehicle if it is there already
		if (val)
		{
			recentVehicles = JSON.parse(val);
			if (Array.isArray(recentVehicles))
			{
				recentVehicles = recentVehicles.filter(item => item.id !== vehicleId);
			}
		}




		await this.storage.set(Constants.IonicStorage_RecentVehicles, JSON.stringify(recentVehicles));
		localStorage.setItem('recent-vehicles-initialised', 'true');

	}

	public saveVehicleStatusInfo(id: string, status: VehicleStatusEnum, comment: string, supplierId: string, setOnYardDate: boolean)
	{

		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', id);
		httpParams = httpParams.append('status', status);
		httpParams = httpParams.append('comment', comment);
		httpParams = httpParams.append('supplierId', supplierId);
		httpParams = httpParams.append('setOnYardDate', setOnYardDate);

		return this.httpClient.patch<string>(Constants.ApiUrl + 'vehicles/' + id + '/Status/', httpParams);
	}

	getVehicleStatusHistory(vehicleId: string): Observable<VehicleStatusHistoryModel[]>
	{
		return this.httpClient.get<VehicleStatusHistoryModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/status/history');
	}

	getVehicleTransferHistory(vehicleId: string): Observable<VehicleTransferHistoryModel[]>
	{
		return this.httpClient.get<VehicleTransferHistoryModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/transfer/history');
	}

	getVehiclePriceHistory(vehicleId: string): Observable<VehiclePriceHistoryModel[]>
	{
		return this.httpClient.get<VehiclePriceHistoryModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/price/history');
	}

    getVehicleOdometerHistory(vehicleId: string): Observable<VehicleOdometerHistoryModel[]>
	{
		return this.httpClient.get<VehicleOdometerHistoryModel[]>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/odometer/history');
	}

    createVehicleOdometerReading(vehicleId: string, newReading: VehicleOdometerHistoryModel): Observable<VehicleOdometerHistoryModel>
	{
		return this.httpClient.post<VehicleOdometerHistoryModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/odometer/new', newReading);
	}


	getVehiclesByVehicleIds(vehicleIds: Array<string>): Observable<Array<VehicleModel>>
	{
		let httpParams = new HttpParams();
		var vehicleIdsString = vehicleIds.join(", ");
		httpParams = httpParams.set('ids', vehicleIdsString);
		httpParams = httpParams.set('sideloadOptions', null)
		return this.httpClient.get<Array<VehicleModel>>(Constants.ApiUrl + 'vehicles/vehicles', { params: httpParams });
	}

	public deleteTradeVehicleFromStock(vehicleId: string, reason: string): Observable<boolean>
	{
        let httpParams = new HttpParams();
		httpParams = httpParams.set('reason', reason);

		return this.httpClient.delete<boolean>(Constants.ApiUrl + 'vehicles/' + vehicleId, { params: httpParams });
	}

	getVehicleTasks(vehicleId: string,
		taskTypeId: string = Constants.EmptyGuid, taskStatusId: string = Constants.EmptyGuid, query: string = '',
		startDate: string = Constants.DateMinimum, endDate: string = Constants.DateMaximum, pageNumber: number = 1
	): Observable<TasksSearchResult>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('taskTypeId', taskTypeId);
		httpParams = httpParams.set('taskStatusId', taskStatusId);
		httpParams = httpParams.set('query', query);
		httpParams = httpParams.set('startDate', startDate);
		httpParams = httpParams.set('endDate', endDate);
		httpParams = httpParams.set('pageNumber', pageNumber.toString());

		return this.httpClient.get<TasksSearchResult>(Constants.ApiUrl + 'vehicles/' + vehicleId + "/Tasks", { params: httpParams });
	}

    baseCurrencyId: string;
    allCurrencies: CurrencyModel[];
	setupCostBreakdownFieldGroups(vehicle: VehicleModel, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
	{
		this.vehicle = vehicle;
		this.editActive = editActive;

		this.generalService.getCachedBaseCurrency().subscribe(currency => {	this.baseCurrencyId = currency.currencyId;});
        this.generalService.getCachedCurrencies().subscribe(currencies => { this.allCurrencies = currencies; });

		this.fieldGroupTabs = [];

		// if the vehicle is imported
		if (vehicle.vehiclePurchase.purchaseType.member == VehiclePurchaseType.Import || vehicle.vehiclePurchase.purchaseType.member == VehiclePurchaseType.OnConsignment)
		{
			if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
			{
				this.fieldGroupTabs.push(new TabModel("Imported costs", this.vehicle.vehiclePurchase, this.getCostBreakdownFieldGroups("importedCosts"), makeDirty, "importedCosts", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
			}

			if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
			{
				this.fieldGroupTabs.push(new TabModel("Local costs", this.vehicle.vehiclePurchase, this.getCostBreakdownFieldGroups("localCosts"), makeDirty, "localCosts", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
			}

			if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
			{
				this.fieldGroupTabs.push(new TabModel("Totals", this.vehicle.vehiclePurchase, this.getCostBreakdownFieldGroups("totalImportCosts"), makeDirty, "totalImportCosts", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
			}
		}
		else
		{
			if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
			{
				this.fieldGroupTabs.push(new TabModel("Purchase costs", this.vehicle.vehiclePurchase, this.getCostBreakdownFieldGroups("purchaseCosts"), makeDirty, "purchaseCosts", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
			}

			if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
			{
				this.fieldGroupTabs.push(new TabModel("Totals", this.vehicle.vehiclePurchase, this.getCostBreakdownFieldGroups("totalCosts"), makeDirty, "totalCosts", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
			}
		}

		return this.fieldGroupTabs;
	}


	public getCostBreakdownFieldGroups(groupId: string): FieldGroupModel[]
	{
		var field_groups: FieldGroupModel[] = [];
		var field_group: FieldGroupModel;
		switch (groupId)
		{

			case "purchaseCosts":

				var purchaseCostExpenses = this.vehicle.vehicleExpenses.expenses.filter(
					x => x.expenseType == VehicleExpenseType.LocalVehicleCost ||
					x.expenseType == VehicleExpenseType.LocalAgentFee ||
					x.expenseType == VehicleExpenseType.LocalFreight ||
					x.expenseType == VehicleExpenseType.LocalOther
				);

				purchaseCostExpenses.forEach(expense =>
				{
					field_group = new FieldGroupModel(expense.shortCaption);
					var isTradeVehicle = this.vehicle.vehiclePurchase.purchaseType.member == VehiclePurchaseType.Trade;
					field_group.editLink = (!(isTradeVehicle && expense.expenseType == VehicleExpenseType.LocalVehicleCost) && !this.vehicle.vehicleLockStatus.locked);
					var baseCurrencyPriceObject = new PriceEditorModel();
					baseCurrencyPriceObject.removeTaxTypes = true;
					baseCurrencyPriceObject.price = { id: "baseAmount", value: expense.baseAmount };
					baseCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
					baseCurrencyPriceObject.mode = "extended";
					baseCurrencyPriceObject.currency = { id: "baseCurrencyId", value: this.baseCurrencyId };
					baseCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
					baseCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
					field_group.addField(new FieldModel("Base currency", expense.baseAmount, "price", "baseAmount", true, false, baseCurrencyPriceObject));

					field_group.addField(new FieldModel("Date", expense.expenseDate, "date", "expenseDate", true, false));
					field_group.addField(new FieldModel("Supplier", expense.supplierId, "contact", "supplierId", true, false, expense.supplier));
					field_group.addField(new FieldModel("Estimate", expense.isEstimate, "toggle", "isEstimate", true, false));
					field_groups.push(field_group);
				});
                break;

			case "importedCosts":
				var importedCostExpenses = this.vehicle.vehicleExpenses.expenses.filter(
					x => x.expenseType == VehicleExpenseType.ImportVehicleCost ||
					x.expenseType == VehicleExpenseType.ImportAgentFee ||
					x.expenseType == VehicleExpenseType.ImportFreight ||
					x.expenseType == VehicleExpenseType.ImportOther ||
					x.expenseType == VehicleExpenseType.ImportTax
				);

				importedCostExpenses.forEach(expense =>
				{
					field_group = new FieldGroupModel(expense.shortCaption);
					field_group.editLink = !this.vehicle.vehicleLockStatus.locked;
					var invoicedCurrencyPriceObject = new PriceEditorModel();
                    invoicedCurrencyPriceObject.editableCurrency = true;
					invoicedCurrencyPriceObject.removeTaxTypes = true;
					invoicedCurrencyPriceObject.price = { id: "expenseAmount", value: expense.expenseAmount };
					invoicedCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
					invoicedCurrencyPriceObject.mode = "extended";
					invoicedCurrencyPriceObject.currency = { id: "expenseCurrencyId", value: expense.expenseCurrencyId };
					invoicedCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
					invoicedCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
					var invoicedCurrency = new FieldModel("Invoiced currency", expense.expenseAmount, "price", "expenseAmount", true, false, invoicedCurrencyPriceObject, null, null, true);
					if (expense.expenseType == VehicleExpenseType.ImportTax)
					{
						invoicedCurrency.editable = !this.vehicle.vehiclePurchase.purchaseFlagsAutoCalcImportTax;
					}
                    invoicedCurrency.hasChildren = true;
                    invoicedCurrency.detailClass = "";
					field_group.addField(invoicedCurrency);

					var exchangeRate = new FieldModel("FX", expense.exchangeRate, "number", "exchangeRate", false, false, null, null, null, true);
                    exchangeRate.parent = "expenseAmount";
					exchangeRate.editable = (expense.expenseCurrencyId != this.baseCurrencyId);
					field_group.addField(exchangeRate);

					var baseCurrencyPriceObject = new PriceEditorModel();
					field_group.editLink = !this.vehicle.vehicleLockStatus.locked;
					baseCurrencyPriceObject.removeTaxTypes = true;
					baseCurrencyPriceObject.price = { id: "baseAmount", value: expense.baseAmount };
					baseCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
					baseCurrencyPriceObject.mode = "extended";
					baseCurrencyPriceObject.currency = { id: "baseCurrencyId", value: this.baseCurrencyId };
					baseCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
					baseCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
					var baseCurrency = new FieldModel("Base currency", expense.baseAmount, "price", "baseAmount", false, false, baseCurrencyPriceObject, null, null, true);
                    baseCurrency.parent = "expenseAmount";
                    field_group.addField(baseCurrency);


					field_group.addField(new FieldModel("Date", expense.expenseDate, "date", "expenseDate", true, false));
					field_group.addField(new FieldModel("Supplier", expense.supplierId, "contact", "supplierId", true, false, expense.supplier));
					field_group.addField(new FieldModel("Estimate", expense.isEstimate, "toggle", "isEstimate", true, false));

					if (expense.expenseType == VehicleExpenseType.ImportTax)
					{
						field_group.addField(new FieldModel("Auto calculate GST", this.vehicle.vehiclePurchase.purchaseFlagsAutoCalcImportTax, "toggle", "purchaseFlagsAutoCalcImportTax", false, false, null, null, null, true));
					}

					field_groups.push(field_group);
				});
				break;

			case "localCosts":

			var localCostExpenses = this.vehicle.vehicleExpenses.expenses.filter(
				x => x.expenseType == VehicleExpenseType.LocalPortServices ||
				x.expenseType == VehicleExpenseType.LocalCustomEntry ||
				x.expenseType == VehicleExpenseType.LocalFreight ||
				x.expenseType == VehicleExpenseType.LocalOther);

				localCostExpenses.forEach(expense =>
				{
					field_group = new FieldGroupModel(expense.shortCaption);
					field_group.editLink = !this.vehicle.vehicleLockStatus.locked;
					var baseCurrencyPriceObject = new PriceEditorModel();
					baseCurrencyPriceObject.removeTaxTypes = true;
					baseCurrencyPriceObject.price = { id: "baseAmount", value: expense.baseAmount };
					baseCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
					baseCurrencyPriceObject.mode = "extended";
					baseCurrencyPriceObject.currency = { id: "baseCurrencyId", value: this.baseCurrencyId };
					baseCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
					baseCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
					field_group.addField(new FieldModel("Base currency", expense.baseAmount, "price", "baseAmount", true, false, baseCurrencyPriceObject));

					field_group.addField(new FieldModel("Date", expense.expenseDate, "date", "expenseDate", true, false));
					field_group.addField(new FieldModel("Supplier", expense.supplierId, "contact", "supplierId", true, false, expense.supplier));
					field_group.addField(new FieldModel("Estimate", expense.isEstimate, "toggle", "isEstimate", true, false));
					field_groups.push(field_group);
				});
				break;

			case "totalCosts":
				field_group = new FieldGroupModel("Total purchase costs");
				field_group.addField(new FieldModel("Total purchase costs", this.vehicle.vehicleExpenses.summaryLocalPurchaseCostsAmountCaption, "text", "summaryLocalPurchaseCostsAmountCaption", false, false, null, null, null, true));
				field_group.addField(new FieldModel("", this.vehicle.vehicleExpenses.summaryLocalPurchaseCostsTaxAmountCaption, "text", "summaryLocalPurchaseCostsTaxAmountCaption", false, false, null, null, null, true));
				field_groups.push(field_group);
				break;

			case "totalImportCosts":
				field_group = new FieldGroupModel("Total import costs");
				field_group.addField(new FieldModel("Total import costs", this.vehicle.vehicleExpenses.summaryImportPurchaseCostsImportAmountCaption, "text", "summaryImportPurchaseCostsImportAmountCaption", false, false, null, null, null, true));
				field_group.addField(new FieldModel("", this.vehicle.vehicleExpenses.summaryImportPurchaseCostsImportTaxAmountCaption, "text", "summaryPurchaseCostsImportTaxAmount", false, false, null, null, null, true));
				field_groups.push(field_group);

				field_group = new FieldGroupModel("Total local costs");
				field_group.addField(new FieldModel("Total local costs", this.vehicle.vehicleExpenses.summaryLocalPurchaseCostsAmountCaption, "text", "summaryLocalPurchaseCostsAmountCaption", false, false, null, null, null, true));
				field_group.addField(new FieldModel("", this.vehicle.vehicleExpenses.summaryLocalPurchaseCostsTaxAmountCaption, "text", "summaryLocalPurchaseCostsTaxAmountCaption", false, false, null, null, null, true));
				field_groups.push(field_group);

				field_group = new FieldGroupModel("Total purchase costs");
				field_group.addField(new FieldModel("Total purchase costs", this.vehicle.vehicleExpenses.summaryImportPurchaseCostsAmountCaption, "text", "summaryImportPurchaseCostsAmountCaption", false, false, null, null, null, true));
				field_group.addField(new FieldModel("", this.vehicle.vehicleExpenses.summaryImportPurchaseCostsTaxAmountCaption, "text", "summaryImportPurchaseCostsTaxAmountCaption", false, false, null, null, null, true));
				field_groups.push(field_group);
				break;
		}
		return field_groups;
	}

    parts: ListItemModel[];
	setupExpenseFieldGroups(expense: VehicleExpenseModel, editableCurrency: boolean, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
	{
		this.editActive = editActive;


		this.generalService.getCachedBaseCurrency().subscribe(currency => {	this.baseCurrencyId = currency.currencyId;});
        this.generalService.getCachedCurrencies().subscribe(currencies => { this.allCurrencies = currencies; });
		this.partService.getCachedParts().subscribe(parts => 
		{
			this.parts = parts.map(y => new ListItemModel(y.partId.toString(), y.name.toString(), null, null, y));
			this.parts.unshift(new ListItemModel("00000000-0000-0000-0000-000000000000", "-"));
		});

		this.fieldGroupTabs = [];

		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
		{
			this.fieldGroupTabs.push(new TabModel("Expense details", expense, this.getExpenseFieldGroups("expenseDetails", expense, editableCurrency), makeDirty, "expenseDetails", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
		}

		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
		{
			this.fieldGroupTabs.push(new TabModel("Expense amount", expense, this.getExpenseFieldGroups("expenseAmount", expense, editableCurrency), makeDirty, "expenseAmount", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
		}

		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView) && !editActive)
		{
			this.fieldGroupTabs.push(new TabModel("Payments", expense, this.getExpenseFieldGroups("payments", expense, editableCurrency), makeDirty, "payments", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
		}

		if (this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView))
		{
			this.fieldGroupTabs.push(new TabModel("Sales order", expense, this.getExpenseFieldGroups("salesOrder", expense, editableCurrency), makeDirty, "salesOrder", "", this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseView), this.userService.hasUserRight(SecurityRight.VehiclesTabsPurchaseEdit)));
		}


		return this.fieldGroupTabs;
	}


	public getExpenseFieldGroups(groupId: string, expense: VehicleExpenseModel, editableCurrency: boolean): FieldGroupModel[]
	{
		var field_groups: FieldGroupModel[] = [];
		var field_group: FieldGroupModel;
		switch (groupId)
		{
			case "expenseDetails":
				field_group = new FieldGroupModel("");

                var expenseTypeOptions = [
					new ListItemModel(VehicleExpenseType.StandardExpense.toString(), "Reconditioning"),
					new ListItemModel(VehicleExpenseType.AfterSaleExpense.toString(), "After-sale"),
				];
				field_group.addField(new FieldModel("Expense type", expense.expenseType, "select", "expenseType", true, false, expenseTypeOptions));
				field_group.addField(new FieldModel("Date", expense.expenseDate, "date", "expenseDate", true, false));
				field_group.addField(new FieldModel("Dealership", expense.dealershipId, "contact", "dealershipId", true, false, expense.dealership));

				var part = new FieldModel("Part", expense.partId, "select", "partId", true, false, this.parts);
                console.log(this.parts);
                part.hasChildren = true;
                field_group.addField(part);
                if (this.editActive || (!this.editActive && expense.partId != Constants.EmptyGuid))
                {
                    var quantity = new FieldModel("Quantity", expense.partQty, "number", "partQty", true, true);
                    quantity.parent = "partId";
                    quantity.editable = (expense.partId != Constants.EmptyGuid);
                    quantity.toggleEditableWhen = Constants.EmptyGuid;
                    quantity.inverseCheck = true;
                    field_group.addField(quantity);
                }
                
				field_group.addField(new FieldModel("Supplier", expense.supplierId, "contact", "supplierId", true, false, expense.supplier));
				field_group.addField(new FieldModel("Reference No", expense.reference, "text", "reference", true, false));
				field_group.addField(new FieldModel("Description", expense.description, "longtext", "description", true, false));
				field_group.addField(new FieldModel("Category", expense.categoryId, "lookup", "categoryId", true, false, expense.category));
				field_group.addField(new FieldModel("Originated from", expense.originCaption, "text", "originCaption", false, false));
                field_group.singleColumn = true;
				field_groups.push(field_group);
				break;

			case "expenseAmount":
				field_group = new FieldGroupModel("");



                var invoicedCurrencyPriceObject = new PriceEditorModel();
                invoicedCurrencyPriceObject.removeTaxTypes = true;
                invoicedCurrencyPriceObject.editableCurrency = editableCurrency;
                invoicedCurrencyPriceObject.price = { id: "expenseAmount", value: expense.expenseAmount };
                invoicedCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
                invoicedCurrencyPriceObject.mode = "extended";
                invoicedCurrencyPriceObject.currency = { id: "expenseCurrencyId", value: expense.expenseCurrencyId };
                invoicedCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
                invoicedCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
                var invoicedCurrency = new FieldModel("Invoiced currency", expense.expenseAmount, "price", "expenseAmount", true, false, invoicedCurrencyPriceObject, null, null, true);
                invoicedCurrency.hasChildren = true;
                invoicedCurrency.detailClass = "";
                field_group.addField(invoicedCurrency);


                var exchangeRate = new FieldModel("FX", expense.exchangeRate, "number", "exchangeRate", false, false, null, null, null, true);
                exchangeRate.parent = "expenseAmount";
                exchangeRate.editable = (expense.expenseCurrencyId != this.baseCurrencyId);
                field_group.addField(exchangeRate);

                var baseCurrencyPriceObject = new PriceEditorModel();
                baseCurrencyPriceObject.removeTaxTypes = true;
                baseCurrencyPriceObject.price = { id: "baseAmount", value: expense.baseAmount };
                baseCurrencyPriceObject.taxType = { id: "expenseTaxStatusEnum", value: expense.expenseTaxStatusEnum };
                baseCurrencyPriceObject.mode = "extended";
                baseCurrencyPriceObject.currency = { id: "baseCurrencyId", value: this.baseCurrencyId };
                baseCurrencyPriceObject.taxRate = { id: "expenseTaxRate", value: expense.expenseTaxRate };
                baseCurrencyPriceObject.taxAmount = { id: "baseTaxAmount", value: expense.baseTaxAmount };
                var baseAmount = new FieldModel("Base currency", expense.baseAmount, "price", "baseAmount", false, false, baseCurrencyPriceObject, null, null, true);
                if (expense.expenseType == VehicleExpenseType.ImportVehicleCost ||
                    expense.expenseType == VehicleExpenseType.ImportAgentFee ||
                    expense.expenseType == VehicleExpenseType.ImportFreight ||
                    expense.expenseType == VehicleExpenseType.ImportOther ||
                    expense.expenseType == VehicleExpenseType.ImportTax)
                {
                    baseAmount.editable = false;
                }
                baseAmount.parent = "expenseAmount";
                field_group.addField(baseAmount);

				field_group.addField(new FieldModel("Estimate", expense.isEstimate, "toggle", "isEstimate", true, false));

				field_group.singleColumn = true;
				field_groups.push(field_group);
				break;

			case "payments":
				field_group = new FieldGroupModel("");
				field_group.addField(new FieldModel("Amount owing", expense.expenseBalance, "currency", "expenseBalance", false, false, null, null, null, true));
				field_group.singleColumn = true;
				field_groups.push(field_group);

				break;
			case "salesOrder":
                field_group = new FieldGroupModel("");

				var saleOrderOptions = [
                    new ListItemModel(VehicleExpenseSaleOrderMode.None.toString(), "None"),
					new ListItemModel(VehicleExpenseSaleOrderMode.VehicleSupplier.toString(), "Vehicle supplier"),
					new ListItemModel(VehicleExpenseSaleOrderMode.SpecificParty.toString(), "Another party"),
				];

				var saleOrderTypes = new FieldModel("Create sales order for", expense.saleOrderMode, "select", "saleOrderMode", true, false, saleOrderOptions);
				saleOrderTypes.hasChildren = true;
				field_group.addField(saleOrderTypes);

                if (this.editActive || expense.saleOrderMode == VehicleExpenseSaleOrderMode.SpecificParty)
                {
                    var otherSupplier = new FieldModel("Other supplier", expense.saleOrderPartyId, "contact", "saleOrderPartyId", true, false, expense.saleOrderParty);
                    otherSupplier.editable = expense.saleOrderMode == VehicleExpenseSaleOrderMode.SpecificParty;
                    otherSupplier.parent = "saleOrderMode";
                    otherSupplier.toggleEditableWhen = VehicleExpenseSaleOrderMode.SpecificParty
                    otherSupplier.toggleVisibleWhen = VehicleExpenseSaleOrderMode.SpecificParty
                    field_group.addField(otherSupplier);
                }

                if (this.editActive || expense.saleOrderMode != VehicleExpenseSaleOrderMode.None)
                {
                    var saleOrderPriceObject = new PriceEditorModel();
                    saleOrderPriceObject.removeTaxTypes = true;
                    saleOrderPriceObject.price = { id: "saleOrderAmount", value: expense.saleOrderAmount };
                    saleOrderPriceObject.taxType = { id: "saleOrderTaxStatusEnum", value: expense.saleOrderTaxStatusEnum };
                    saleOrderPriceObject.mode = "extended";
                    saleOrderPriceObject.currency = { id: "baseCurrencyId", value: this.baseCurrencyId };
                    saleOrderPriceObject.taxRate = { id: "saleOrderTaxRate", value: expense.saleOrderTaxRate };
                    saleOrderPriceObject.taxAmount = { id: "saleOrderTaxAmount", value: expense.saleOrderTaxAmount };
                    var saleOrderAmount = new FieldModel("Sale Order", expense.saleOrderAmount, "price", "saleOrderAmount", true, false, saleOrderPriceObject);
                    saleOrderAmount.editable = expense.saleOrderMode != VehicleExpenseSaleOrderMode.None;
                    saleOrderAmount.parent = "saleOrderMode";
                    saleOrderAmount.toggleEditableWhen = VehicleExpenseSaleOrderMode.SpecificParty + "|" + VehicleExpenseSaleOrderMode.VehicleSupplier;
                    saleOrderAmount.toggleVisibleWhen = VehicleExpenseSaleOrderMode.SpecificParty + "|" + VehicleExpenseSaleOrderMode.VehicleSupplier;
                    field_group.addField(saleOrderAmount);
                }

				field_group.singleColumn = true;
				field_groups.push(field_group);
				break;

		}
		return field_groups;
	}

	formatSummaryPrice(price: number, applicable: boolean = true): string
	{
		if (applicable)
		{
			if (price % 1 > 0)
			{
				return this.decimalPipe.transform(price, '1.2-2');
			}
			return this.decimalPipe.transform(price, '1.0-0');
		}
		else
		{
			return 'N/A';
		}
	}


	public setupVehicleExpensePaymentsFieldGroups(expense: VehicleExpenseModel): any[]
	{
		let field_groups = [];
		let group = new FieldGroupModel("");

		if (expense.vehicleExpensePayments && expense.vehicleExpensePayments.length > 0)
		{
			for (let payment of expense.vehicleExpensePayments)
			{

				//create date from payment date
				var paymentDate = new Date(payment.paymentDate);

				//create a variable of payment amount as a currency
				var paymentDetails = new FieldModel(paymentDate.toDateString(), payment.paymentAmount.toString(), "currency");
				paymentDetails.id = payment.vehicleExpPaymentId;
				paymentDetails.sublabel = payment.reference || '-';
				// paymentDetails.subvalue = payment.description || '-';
				paymentDetails.detailObject = payment;
				paymentDetails.detailObject.type = "payment";
				paymentDetails.classes = 'vehicle-activity-list-item';
				paymentDetails.detail = true;
				group.addField(paymentDetails);
			}
		}

		group.singleColumn = true;
		field_groups.push(group);

		return field_groups;
	}

    public getVehicleExpenseTemplate(vehicleId: string, expenseType: VehicleExpenseType): Observable<VehicleExpenseModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('expenseType', expenseType.toString());
        return this.httpClient.get<VehicleExpenseModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Expense/new', { params: httpParams });
    }

    public deleteVehicleExpense(vehicleId: string, expenseId: string): Observable<boolean>
    {
        return this.httpClient.delete<boolean>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Expenses/' + expenseId);
    }

	public getVehicleExpensePaymentTemplate(expenseId: string): Observable<VehicleExpensePaymentModel>
	{
		return this.httpClient.get<VehicleExpensePaymentModel>(Constants.ApiUrl + 'vehicles/' + expenseId + '/Payment');
	}

	public createVehicleExpensePayment(expenseId: string, payment: VehicleExpensePaymentModel): Observable<VehicleExpensePaymentModel>
	{
		return this.httpClient.post<VehicleExpensePaymentModel>(Constants.ApiUrl + 'vehicles/' + expenseId + '/Payment', payment);
	}

	public deleteVehicleExpensePayment(vehicleId: string, expenseId: string, paymentId: string): Observable<VehicleExpenseModel>
	{
		return this.httpClient.delete<VehicleExpenseModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Expense/' + expenseId + '/Payment/' + paymentId);
	}

    public getVehicleExpenses(vehicleId: string, includeGST: boolean = true): Observable<VehicleExpensesModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('includeGST', includeGST);
        return this.httpClient.get<VehicleExpensesModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Expenses', { params: httpParams });
    }

    public calculateVehicleProfit(vehicleId: string, vehiclePayload: VehicleProfitCalculatorModel): Observable<VehicleExpensesModel>
    {
        return this.httpClient.post<VehicleExpensesModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/Calculate/Profit', vehiclePayload);
    }

	public getVehicleImageUrl(id: string, image: VehicleImageModel = null, thumb: boolean = true): string
	{
		if (!image)
		{
			return Constants.PlaceholderCarUrl;
		}
		if (image.attachmentUrl)
		{
			return image.attachmentUrl;
		}
		return `${Constants.ApiUrl}vehicles/${id}/images/${(thumb ? image.thumbnailId : image.fullSizeId)}`;
	}


    public handleFieldChangedForTabs(ev:any, fieldGroupTabs:TabModel[])
    {
        // console.log("handleFieldChangedForTabs", ev);

        //see if this field has children
        var changedField: FieldModel = ev.detail.field;
        if (changedField.hasChildren)
        {
            switch (changedField.type)
            {
                case "price":
                    if (ev.detail.field.detailObject)
                    {
                        this.checkCurrencyChildren(changedField, <PriceEditorModel>ev.detail.field.detailObject, fieldGroupTabs);
                    }
                    break;
            }
        }
    }

    public checkCurrencyChildren(changedField: FieldModel, priceEditorFields: PriceEditorModel, fieldGroupTabs: TabModel[], togglePostal=false)
    {

        var prefix = changedField.detailClass;
        // console.log("checkAddressChildren", changedField);
        for (let field_group_tab of fieldGroupTabs)
        {
            for (let field_group of field_group_tab.fieldGroups)
            {
                for (let field_test of field_group.fields)
                {
                    if (field_test.parent == changedField.id)
                    {
                        // console.log("found a child, " + field_test.id);

                        var fieldWithoutPrefix = field_test.id.replace(prefix, '');
                        field_test.dirty = true;

                        // console.log(fieldWithoutPrefix);
                        switch (fieldWithoutPrefix)
                        {
                            case "baseAmount":
                                var currentCurrency: CurrencyModel = this.allCurrencies.find(currency => currency.currencyId == priceEditorFields.currency.value);
                                field_test.value = changedField.value / currentCurrency.exchangeRate;
                                field_test.detailObject.price.value = field_test.value;
                                field_test.detailObject.taxType.value = changedField.detailObject.taxType.value;
                                field_test.valueChanged$.next(null);
                                break;
                            case "exchangeRate":
                                // Make the exchange rate editable if the currency is not the base currency
                                var currentCurrency: CurrencyModel = this.allCurrencies.find(currency => currency.currencyId == priceEditorFields.currency.value);
                                field_test.editable = currentCurrency.currencyId != this.baseCurrencyId;
                                field_test.value = currentCurrency.exchangeRate;
                                field_test.valueChanged$.next(null);
                                break;
                        }

                    }
                }
            }
        }
    }


    async sellVehicle(vehicle: VehicleSummaryModel) {

        const modal = await this.modalController.create({
            component: SelectContactSearchComponent,
            componentProps: {
                title: "Select customer",
                contactClass: ContactClass.All,
                contactType: ContactType.Customer,
                placeholderText: "Search for mobile or email"
            }
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();

        if (data && data.contact) {
            // Fix: Use contactId if id is missing
            const contactId = data.contact.id ?? data.contact.contactId ?? null;
            if (!contactId) {
                this.presentAlert("Error", "Customer ID not found.");
                return;
            }

            const loading = await this.loadingController.create({
                message: 'Creating sale...',
                duration: 60000
            });
            await loading.present();

            this.saleService.getNewSaleTemplate().subscribe({
                next: newSale => {

                    this.saleService.createSaleForCustomer(newSale, contactId).subscribe({
                        next: savedSale => {

                            this.saleService.getSaleVehicleTemplate(savedSale.saleId, vehicle.vehicleId, SaleVehicleType.Sale)
                                .subscribe({
                                    next: newSaleVehicle =>
                                    {
                                        this.saleService.createSaleVehicle(savedSale.saleId, newSaleVehicle)
                                            .subscribe({
                                                next: saleVehicle =>
                                                {
                                                    loading.dismiss();
                                                    this.saleService.saleMessage.next(savedSale);
                                                    this.navCtrl.navigateForward(`/sales/${savedSale.saleId}`);
                                                },
                                                error: err =>
                                                {
                                                    loading.dismiss();
                                                    this.presentAlert("Error", "Failed to create sale vehicle.");
                                                    this.navCtrl.navigateForward(`/sales/${savedSale.saleId}`);
                                                }
                                            });
                                    },
                                    error: err =>
                                    {
                                        loading.dismiss();
                                        this.presentAlert("Error", "Failed to load sale vehicle template.");
                                        this.navCtrl.navigateForward(`/sales/${savedSale.saleId}`);
                                    }
                                });

                        },
                        error: err => {
                            loading.dismiss();
                            this.presentAlert("Error", "Failed to create sale.");
                        }
                    });
                },
                error: err => {
                    loading.dismiss();
                    this.presentAlert("Error", "Failed to load sale template.");
                }
            });
        }
    }

    copyVehicleById(vehicleId: string, includeExportFields: boolean = false)
	{
		let httpParams = new HttpParams();
        httpParams = httpParams.append('exportFields', includeExportFields);
		return this.httpClient.get<VehicleModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/copy', { params: httpParams } );
	}

    copyVehicleImagesById(sourceVehicleId: string, targetVehicleId: string): Observable<VehicleModel>
	{
		return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'vehicles/' + sourceVehicleId + '/copyImages/' + targetVehicleId, null);
	}

    getVehicleCarcheckInfo(vehicleId: string): Observable<VehicleModel>
    {
        return this.httpClient.get<VehicleModel>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/carcheck');
    }

    public validEmail(email: string): boolean
	{
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	}

    requestDigitalSigning(vehicleId: string): Observable<VehicleModel>
    {
        return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/RequestDigitalSigningForVehicle', null);
    }

    revokeDigitalSigning(vehicleId: string, cancellationReason: string): Observable<VehicleModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('cancellationReason', cancellationReason);
        return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/RevokeDigitalSigningForVehicle', httpParams);
    }

    purchaseVehicle(vehicleId: string): Observable<VehicleModel>
    {
        return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/purchaseVehicle', null);
    }

    returnVehicleToSupplier(vehicleId: string): Observable<VehicleModel>
    {
        return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/returnVehicleToSupplier', null);
    }

    updateVehicleStockNumber(vehicleId: string, stockNo: number): Observable<VehicleModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('stockNo', stockNo);
        return this.httpClient.patch<VehicleModel>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/updateVehicleStockNumber', httpParams);
    }

    generatePurchaseOrderForExpense(vehicleId: string, expenseId: string): Observable<string>
    {
        return this.httpClient.post<string>(Constants.ApiUrl + 'Vehicles/' + vehicleId + '/Expense/' + expenseId + '/PurchaseOrders', null);
    }
        
    bulkUpdateVehicles(request: BulkUpdateRequestModel): Observable<BooleanResultModel>
    {
        return this.httpClient.post<BooleanResultModel>(Constants.ApiUrl + 'vehicles/bulkUpdate', request);
    }

    performDuplicateVehicleDetection(vehicleId: string, plateVin: string, checkType: PlateVinCheck): Observable<string>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('plateVin', plateVin);
        httpParams = httpParams.set('checkType', checkType);
        return this.httpClient.get<string>(Constants.ApiUrl + 'vehicles/' + vehicleId + '/duplicatePlateVinCheck', { params: httpParams });
    }

    public canDeleteVehicleActivities(activities: OpportunityActivityResultModel[]): boolean
    {
        if (!activities || activities.length === 0)
        {
            return true;
        }

        for (const activity of activities)
        {
            switch (activity.activityTypeName?.toLowerCase())
            {
                case 'quote':
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeleteQuote)) return false;
                    break;
                case 'financeapplication':
                case 'financeapp':
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeleteFinanceApp)) return false;
                    break;
                case 'testdrive':
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeleteTestDrive)) return false;
                    break;
                case 'loanvehicle':
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeleteLoanVehicle)) return false;
                    break;
                case 'pricemytrade':
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeletePriceMyTrade)) return false;
                    break;
                default:
                    if (!this.userService.hasUserRight(SecurityRight.OpportFunctionsDeleteOther)) return false;
                    break;
            }
        }
        return true;
    }

}

